(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[781],{

/***/ 40000:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const STAR = 'M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z';
const IconStar = lib.variant('IconStar', icon.Icon, {
    path: STAR,
});

exports.G = IconStar;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 51722:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},D="en",v={};v[D]=M;var p=function(t){return t instanceof _},S=function(t,e,n){var r;if(!t)return D;if("string"==typeof t)v[t]&&(r=t),e&&(v[t]=e,r=t);else{var i=t.name;v[i]=t,r=i}return!n&&r&&(D=r),r||!n&&D},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var D=this.$locale().weekStart||0,v=(y<D?y+7:y)-D;return $(r?m-v:m+(6-v),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].substr(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,D=O.m(this,M);return D=(l={},l[c]=D/12,l[f]=D,l[h]=D/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?D:O.a(D)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return v[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),b=_.prototype;return w.prototype=b,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){b[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=v[D],w.Ls=v,w.p={},w}));

/***/ }),

/***/ 31420:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 88987:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hashClear = __webpack_require__(71519),
    hashDelete = __webpack_require__(82999),
    hashGet = __webpack_require__(76111),
    hashHas = __webpack_require__(50506),
    hashSet = __webpack_require__(80845);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 175:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var listCacheClear = __webpack_require__(2173),
    listCacheDelete = __webpack_require__(33752),
    listCacheGet = __webpack_require__(10548),
    listCacheHas = __webpack_require__(63410),
    listCacheSet = __webpack_require__(3564);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 35922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 9440:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var mapCacheClear = __webpack_require__(7140),
    mapCacheDelete = __webpack_require__(56504),
    mapCacheGet = __webpack_require__(88833),
    mapCacheHas = __webpack_require__(80953),
    mapCacheSet = __webpack_require__(70724);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 6795:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 81956:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 78188:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var MapCache = __webpack_require__(9440),
    setCacheAdd = __webpack_require__(96659),
    setCacheHas = __webpack_require__(97230);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 5929:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175),
    stackClear = __webpack_require__(40551),
    stackDelete = __webpack_require__(4090),
    stackGet = __webpack_require__(47694),
    stackHas = __webpack_require__(86220),
    stackSet = __webpack_require__(68958);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 92210:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(29165);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 69477:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 48969:
/***/ ((module) => {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 45170:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIndexOf = __webpack_require__(13807);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 94936:
/***/ ((module) => {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ 79809:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseTimes = __webpack_require__(39739),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isBuffer = __webpack_require__(61563),
    isIndex = __webpack_require__(91010),
    isTypedArray = __webpack_require__(73806);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 75697:
/***/ ((module) => {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 28486:
/***/ ((module) => {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 49499:
/***/ ((module) => {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 62718:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var eq = __webpack_require__(42448);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 92504:
/***/ ((module) => {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 97499:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var castPath = __webpack_require__(60399),
    toKey = __webpack_require__(77817);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 38084:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayPush = __webpack_require__(28486),
    isArray = __webpack_require__(24669);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 71664:
/***/ ((module) => {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 13807:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseFindIndex = __webpack_require__(92504),
    baseIsNaN = __webpack_require__(99940),
    strictIndexOf = __webpack_require__(3729);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 84742:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 6620:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsEqualDeep = __webpack_require__(83977),
    isObjectLike = __webpack_require__(55073);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 83977:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Stack = __webpack_require__(5929),
    equalArrays = __webpack_require__(22684),
    equalByTag = __webpack_require__(7456),
    equalObjects = __webpack_require__(18120),
    getTag = __webpack_require__(81887),
    isArray = __webpack_require__(24669),
    isBuffer = __webpack_require__(61563),
    isTypedArray = __webpack_require__(73806);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 27122:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Stack = __webpack_require__(5929),
    baseIsEqual = __webpack_require__(6620);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 99940:
/***/ ((module) => {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 58939:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isFunction = __webpack_require__(92042),
    isMasked = __webpack_require__(90654),
    isObject = __webpack_require__(36838),
    toSource = __webpack_require__(51059);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 22882:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isLength = __webpack_require__(17216),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 5673:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseMatches = __webpack_require__(3772),
    baseMatchesProperty = __webpack_require__(30493),
    identity = __webpack_require__(48148),
    isArray = __webpack_require__(24669),
    property = __webpack_require__(51798);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 87473:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isPrototype = __webpack_require__(92963),
    nativeKeys = __webpack_require__(14457);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 3772:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsMatch = __webpack_require__(27122),
    getMatchData = __webpack_require__(67487),
    matchesStrictComparable = __webpack_require__(78857);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 30493:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsEqual = __webpack_require__(6620),
    get = __webpack_require__(65439),
    hasIn = __webpack_require__(28281),
    isKey = __webpack_require__(2610),
    isStrictComparable = __webpack_require__(92769),
    matchesStrictComparable = __webpack_require__(78857),
    toKey = __webpack_require__(77817);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 17498:
/***/ ((module) => {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 71000:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGet = __webpack_require__(97499);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 39739:
/***/ ((module) => {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 73150:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(74396),
    arrayMap = __webpack_require__(75697),
    isArray = __webpack_require__(24669),
    isSymbol = __webpack_require__(16764);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 58792:
/***/ ((module) => {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 95453:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var SetCache = __webpack_require__(78188),
    arrayIncludes = __webpack_require__(45170),
    arrayIncludesWith = __webpack_require__(94936),
    cacheHas = __webpack_require__(29880),
    createSet = __webpack_require__(17319),
    setToArray = __webpack_require__(79967);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ 29880:
/***/ ((module) => {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 60399:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArray = __webpack_require__(24669),
    isKey = __webpack_require__(2610),
    stringToPath = __webpack_require__(26365),
    toString = __webpack_require__(8389);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 36633:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(29165);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 17319:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Set = __webpack_require__(81956),
    noop = __webpack_require__(43226),
    setToArray = __webpack_require__(79967);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ 22684:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var SetCache = __webpack_require__(78188),
    arraySome = __webpack_require__(49499),
    cacheHas = __webpack_require__(29880);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 7456:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(74396),
    Uint8Array = __webpack_require__(92210),
    eq = __webpack_require__(42448),
    equalArrays = __webpack_require__(22684),
    mapToArray = __webpack_require__(7523),
    setToArray = __webpack_require__(79967);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 18120:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getAllKeys = __webpack_require__(69698);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 69698:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetAllKeys = __webpack_require__(38084),
    getSymbols = __webpack_require__(97482),
    keys = __webpack_require__(50579);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 67707:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isKeyable = __webpack_require__(3880);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 67487:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isStrictComparable = __webpack_require__(92769),
    keys = __webpack_require__(50579);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 47758:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsNative = __webpack_require__(58939),
    getValue = __webpack_require__(9149);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 97482:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayFilter = __webpack_require__(48969),
    stubArray = __webpack_require__(68036);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 81887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DataView = __webpack_require__(31420),
    Map = __webpack_require__(35922),
    Promise = __webpack_require__(6795),
    Set = __webpack_require__(81956),
    WeakMap = __webpack_require__(69477),
    baseGetTag = __webpack_require__(80732),
    toSource = __webpack_require__(51059);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 9149:
/***/ ((module) => {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 18554:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var castPath = __webpack_require__(60399),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isIndex = __webpack_require__(91010),
    isLength = __webpack_require__(17216),
    toKey = __webpack_require__(77817);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 71519:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 82999:
/***/ ((module) => {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 76111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 50506:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 80845:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 91010:
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 2610:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArray = __webpack_require__(24669),
    isSymbol = __webpack_require__(16764);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 3880:
/***/ ((module) => {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 90654:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var coreJsData = __webpack_require__(36633);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 92963:
/***/ ((module) => {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 92769:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(36838);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 2173:
/***/ ((module) => {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 33752:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 10548:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 63410:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 3564:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 7140:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Hash = __webpack_require__(88987),
    ListCache = __webpack_require__(175),
    Map = __webpack_require__(35922);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 56504:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 88833:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 80953:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 70724:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 7523:
/***/ ((module) => {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 78857:
/***/ ((module) => {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 45171:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var memoize = __webpack_require__(34736);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 37722:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 14457:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var overArg = __webpack_require__(75542);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 8478:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(96476);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 75542:
/***/ ((module) => {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 96659:
/***/ ((module) => {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 97230:
/***/ ((module) => {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 79967:
/***/ ((module) => {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 40551:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 4090:
/***/ ((module) => {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 47694:
/***/ ((module) => {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 86220:
/***/ ((module) => {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 68958:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175),
    Map = __webpack_require__(35922),
    MapCache = __webpack_require__(9440);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 3729:
/***/ ((module) => {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 26365:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var memoizeCapped = __webpack_require__(45171);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 77817:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isSymbol = __webpack_require__(16764);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 51059:
/***/ ((module) => {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 42448:
/***/ ((module) => {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 65439:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGet = __webpack_require__(97499);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 28281:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseHasIn = __webpack_require__(71664),
    hasPath = __webpack_require__(18554);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 48148:
/***/ ((module) => {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 30353:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsArguments = __webpack_require__(84742),
    isObjectLike = __webpack_require__(55073);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 24669:
/***/ ((module) => {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 47428:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isFunction = __webpack_require__(92042),
    isLength = __webpack_require__(17216);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 61563:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(29165),
    stubFalse = __webpack_require__(84193);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 92042:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isObject = __webpack_require__(36838);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 17216:
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 73806:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsTypedArray = __webpack_require__(22882),
    baseUnary = __webpack_require__(58792),
    nodeUtil = __webpack_require__(8478);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 50579:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayLikeKeys = __webpack_require__(79809),
    baseKeys = __webpack_require__(87473),
    isArrayLike = __webpack_require__(47428);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 34736:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var MapCache = __webpack_require__(9440);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 43226:
/***/ ((module) => {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 51798:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseProperty = __webpack_require__(17498),
    basePropertyDeep = __webpack_require__(71000),
    isKey = __webpack_require__(2610),
    toKey = __webpack_require__(77817);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 68036:
/***/ ((module) => {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 84193:
/***/ ((module) => {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 8389:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseToString = __webpack_require__(73150);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 2600:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIteratee = __webpack_require__(5673),
    baseUniq = __webpack_require__(95453);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),

/***/ 11341:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": () => (/* binding */ Badge)
/* harmony export */ });
/* unused harmony export Text */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25349);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21541);
/* harmony import */ var src_areas_expert_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46674);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Badge = function(props) {
    var type = props.type;
    var t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il).t;
    var text = (0,src_areas_expert_utils__WEBPACK_IMPORTED_MODULE_5__/* .getTranslationByContentType */ .r)(type, t);
    return text ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, text) : null;
};
var Text = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__.TitleMediumText).withConfig({
    displayName: "Text",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium, function(p) {
    return p.theme.colors.maybeBlue700;
});


/***/ }),

/***/ 53973:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ expert_avatar)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/components/user-avatar/index.tsx + 1 modules
var user_avatar = __webpack_require__(60738);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/expert/components/expert-avatar/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: fit-content;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ExpertAvatar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExpertAvatar",
    componentId: "sc-0-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/areas/expert/components/expert-avatar/index.tsx





var expert_avatar_ExpertAvatar = function(param) {
    var avatar = param.avatar, className = param.className, displayName = param.displayName, link = param.link, size = param.size;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), renderMode = ref.renderMode, linkTo = ref.linkTo;
    var children = /*#__PURE__*/ react.createElement(user_avatar/* UserAvatar */.Y, {
        size: size,
        avatar: avatar,
        displayName: displayName
    });
    return /*#__PURE__*/ react.createElement(ExpertAvatar, {
        className: className
    }, link ? /*#__PURE__*/ react.createElement(clickable/* Clickable */.P, {
        to: linkTo("expertProfile", {
            semantic_id: link || ""
        }, renderMode === "native" ? {
            view: "native"
        } : undefined)
    }, children) : children);
};
/* harmony default export */ var expert_avatar = (expert_avatar_ExpertAvatar);


/***/ }),

/***/ 8454:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": () => (/* binding */ ExpertUserCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/areas/expert/components/expert-avatar/index.tsx + 1 modules
var expert_avatar = __webpack_require__(53973);
// EXTERNAL MODULE: ./src/areas/expert/types.ts
var types = __webpack_require__(54712);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/expert/components/expert-user-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    align-self: center;\n    grid-area: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  grid-area: 1 / 1 / 3 / 2;\n  align-self: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    display: grid;\n    grid-template-columns: ",
        "px 1fr;\n    grid-template-rows: auto auto;\n    column-gap: ",
        ";\n    margin-left: ",
        ";\n    z-index: ",
        ";\n\n    p {\n      margin: 0;\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    ",
        "\n    max-height: ",
        "px;\n\n    &[href]:hover {\n      ",
        " {\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var USER_AVATAR_SIZE_SMALL = 32;
var USER_AVATAR_SIZE_MEDIUM = 48;
var Title = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Title",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject(), props.$showSubtitle ? "1 / 2 / 2 / 3" : "1 / 2 / 3 / 3");
});
var Subtitle = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject1(), props.$size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal : base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
});
var Avatar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Avatar",
    componentId: "sc-0-2"
})(_templateObject2());
var Expert = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Expert",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject3(), props.$size, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, props.$overlap ? "-".concat(props.$size * props.$overlap / 2, "px") : "0", props.$index);
});
var Container = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "Container",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), props.$pointer ? "cursor: pointer;" : "", props.$size, Title, props.theme.text.callToActionHover);
});

;// CONCATENATED MODULE: ./src/areas/expert/components/expert-user-card/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}








var ExpertUserCard = function(props) {
    var className = props.className, customTitle = props.customTitle, experts = props.experts, _size = props.size, size = _size === void 0 ? types/* ExpertUserCardSize.SMALL */.M.SMALL : _size, subtitle = props.subtitle, _pointer = props.pointer, pointer = _pointer === void 0 ? false : _pointer;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, renderMode = ref.renderMode, linkTo = ref.linkTo;
    var avatarSize = size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? USER_AVATAR_SIZE_MEDIUM : USER_AVATAR_SIZE_SMALL;
    var container = experts.length === 1 ? clickable/* Clickable */.P : "div";
    var containerProps = experts.length === 1 && experts[0].url ? {
        to: linkTo("expertProfile", {
            semantic_id: experts[0].url
        }, renderMode === "native" ? {
            view: "native"
        } : undefined),
        isExternal: renderMode === "native",
        onClick: function() {
            if (experts[0].url) {
                (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.EXPERT_PROFILE_GO_TO */.U.EXPERT_PROFILE_GO_TO,
                    nextPage: experts[0].url
                });
            }
        }
    } : undefined;
    var getSingularExpertText = function(expert) {
        if (customTitle) return /*#__PURE__*/ react.createElement(Title, {
            $showSubtitle: false
        }, customTitle);
        return /*#__PURE__*/ react.createElement(react.Fragment, null, size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? /*#__PURE__*/ react.createElement(Title, {
            $showSubtitle: Boolean(subtitle)
        }, /*#__PURE__*/ react.createElement(variants.TitleMediumText, {
            behavior: variants.Behavior.Oneline
        }, expert.name)) : /*#__PURE__*/ react.createElement(Title, {
            $showSubtitle: Boolean(subtitle)
        }, /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
            behavior: variants.Behavior.Oneline
        }, expert.name)));
    };
    var getPluralExpertText = function() {
        if (customTitle) return /*#__PURE__*/ react.createElement(Title, {
            $showSubtitle: false
        }, customTitle);
        return /*#__PURE__*/ react.createElement(react.Fragment, null, size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? /*#__PURE__*/ react.createElement(Title, null, /*#__PURE__*/ react.createElement(variants.TitleMediumText, {
            behavior: variants.Behavior.Oneline
        }, t("expert", "guide.lists-expert-plural", {
            count: experts.length
        }))) : /*#__PURE__*/ react.createElement(Title, null, /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
            behavior: variants.Behavior.Oneline
        }, t("expert", "guide.lists-expert-plural", {
            count: experts.length
        }))));
    };
    return /*#__PURE__*/ react.createElement(Container, _extends({
        className: className,
        as: container,
        $size: avatarSize,
        $pointer: experts.length === 1 && pointer
    }, containerProps), experts.map(function(expert, index) {
        return /*#__PURE__*/ react.createElement(Expert, {
            key: expert.name,
            $index: experts.length - index,
            $overlap: index,
            $size: avatarSize
        }, /*#__PURE__*/ react.createElement(Avatar, null, /*#__PURE__*/ react.createElement(expert_avatar/* default */.Z, {
            avatar: expert.avatar,
            displayName: expert.avatarAlt || expert.name,
            size: avatarSize
        })), experts.length === 1 && getSingularExpertText(expert), experts.length > 1 && index === experts.length - 1 && getPluralExpertText());
    }));
};


/***/ }),

/***/ 8263:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": () => (/* binding */ TrackingSource),
  "Z": () => (/* binding */ list_of_content_cards)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/article-card/index.tsx + 1 modules
var article_card = __webpack_require__(55445);
// EXTERNAL MODULE: ./src/areas/expert/components/card-image/index.tsx
var card_image = __webpack_require__(59669);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/expert/components/product-images/index.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      &::after {\n        ",
        ";\n        pointer-events: none;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: column;\n  column-gap: ",
        ";\n  position: relative;\n  padding: 0 ",
        ";\n  align-items: center;\n  width: 100%;\n  height: ",
        ";\n\n  img {\n    max-height: 64px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var spacing100 = base/* layout.measurements.spacing100 */.bK.measurements.spacing100;
var Images = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Images",
    componentId: "sc-0-0"
})(_templateObject1(), spacing100, spacing100, function(p) {
    return p.height;
}, function(p) {
    return p.background && (0,styled_components_browser_esm.css)(_templateObject(), base/* styledUtils.overlay */.au.overlay());
});
var ProductImages = function(param) {
    var products = param.products, _selectedPosition = param.selectedPosition, selectedPosition = _selectedPosition === void 0 ? 1 : _selectedPosition, _height = param.height, height = _height === void 0 ? "auto" : _height, _background = param.background, background = _background === void 0 ? true : _background;
    // Select the two closest product images to the selected product
    var visible = 3;
    var productImages = products.filter(function(item) {
        if (selectedPosition === 1) return item.order <= visible;
        if (selectedPosition === products.length) return item.order > products.length - visible;
        return item.order === selectedPosition - 1 || item.order === selectedPosition || item.order === selectedPosition + 1;
    }).map(function(p) {
        var ref, ref1, ref2;
        return (p.image || ((ref = p.media) === null || ref === void 0 ? void 0 : ref.first)) && /*#__PURE__*/ react.createElement("img", {
            alt: p.name,
            key: p.image || ((ref1 = p.media) === null || ref1 === void 0 ? void 0 : ref1.first),
            src: p.image || ((ref2 = p.media) === null || ref2 === void 0 ? void 0 : ref2.first)
        });
    });
    return /*#__PURE__*/ react.createElement(Images, {
        background: background,
        height: height
    }, productImages);
};


// EXTERNAL MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/utils.ts
var utils = __webpack_require__(74596);
// EXTERNAL MODULE: ./src/areas/expert/types.ts
var types = __webpack_require__(54712);
// EXTERNAL MODULE: ./src/areas/expert/components/badge/index.tsx
var badge = __webpack_require__(11341);
// EXTERNAL MODULE: ./src/areas/expert/components/expert-user-card/index.tsx + 1 modules
var expert_user_card = __webpack_require__(8454);
// EXTERNAL MODULE: ./src/components/advized/tracking.ts
var tracking = __webpack_require__(98864);
// EXTERNAL MODULE: ./src/areas/expert/components/rating/index.tsx + 1 modules
var rating = __webpack_require__(1946);
;// CONCATENATED MODULE: ./src/areas/expert/components/list-of-content-cards/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  left: ",
        ";\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Rating = (0,styled_components_browser_esm["default"])(rating/* default */.Z).withConfig({
    displayName: "Rating",
    componentId: "sc-0-0"
})(styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking_tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./node_modules/.pnpm/dayjs@1.10.7/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(51722);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/areas/expert/components/list-of-content-cards/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}













var TrackingSource;
(function(TrackingSource) {
    TrackingSource["ADVIZED_WIDGET"] = "advizedWidget";
})(TrackingSource || (TrackingSource = {}));
var ContentCards = function(param) {
    var category = param.category, className = param.className, onClick = param.onClick, items = param.items, _imageSize = param.imageSize, imageSize = _imageSize === void 0 ? 130 : _imageSize, _limit = param.limit, limit = _limit === void 0 ? 0 : _limit, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset, hideExperts = param.hideExperts, trackingSource = param.trackingSource;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), market = ref.market, t = ref.t;
    var linkTo = (0,app_context/* useAppContext */.bp)().linkTo;
    var numberOfCards = limit ? limit + offset : items.length;
    var getDefaultExpert = function() {
        return {
            avatar: "".concat(market.cdn, "/g/rfe/logos/logo_v2_symbol.svg"),
            name: t("search", "editorial.defaultauthor"),
            url: undefined,
            hideExpertIcon: true
        };
    };
    var getPrismicExpert = function(param) {
        var avatar = param.avatar, author = param.author;
        return {
            avatar: (avatar === null || avatar === void 0 ? void 0 : avatar.url) || "".concat(market.cdn, "/g/rfe/logos/logo_v2_symbol.svg"),
            avatarAlt: (avatar === null || avatar === void 0 ? void 0 : avatar.alt) || "",
            name: author || "",
            url: undefined,
            hideExpertIcon: true
        };
    };
    var getNavigationScope = function(clickInfo) {
        switch(clickInfo.type){
            case types/* ContentTypes.ARTICLE */.b.ARTICLE:
                return tracking_tracking/* InternalNavigationScope.ARTICLE_PAGE_GO_TO */.U.ARTICLE_PAGE_GO_TO;
            case types/* ContentTypes.GUIDE */.b.GUIDE:
                return tracking_tracking/* InternalNavigationScope.GUIDE_PAGE_GO_TO */.U.GUIDE_PAGE_GO_TO;
            case types/* ContentTypes.TEST */.b.TEST:
                return tracking_tracking/* InternalNavigationScope.PRODUCT_TEST_PAGE_GO_TO */.U.PRODUCT_TEST_PAGE_GO_TO;
            case types/* ContentTypes.TOPLIST */.b.TOPLIST:
                return tracking_tracking/* InternalNavigationScope.TOPLIST_PAGE_GO_TO */.U.TOPLIST_PAGE_GO_TO;
            case types/* ContentTypes.TOPLIST_HEADLINE */.b.TOPLIST_HEADLINE:
                return tracking_tracking/* InternalNavigationScope.TOPLIST_PAGE_HEADLINE_GO_TO */.U.TOPLIST_PAGE_HEADLINE_GO_TO;
            default:
                return null;
        }
    };
    var onClickAndTracking = function(clickInfo) {
        onClick === null || onClick === void 0 ? void 0 : onClick(clickInfo);
        switch(trackingSource){
            case TrackingSource.ADVIZED_WIDGET:
                {
                    (0,tracking/* trackCategoryPageExpertCarouselCard */.t)(category === null || category === void 0 ? void 0 : category.url, clickInfo.type);
                    break;
                }
            default:
        }
        var scope = getNavigationScope(clickInfo);
        if (scope) {
            (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                scope: scope,
                nextPage: clickInfo.url,
                index: clickInfo.index
            });
        }
    };
    var getContentCard = function(item, index) {
        switch(item.__typename){
            case types/* ContentTypes.TOPLIST_HEADLINE */.b.TOPLIST_HEADLINE:
                {
                    var ref, ref1, ref2, ref3, ref4;
                    if (!item.toplists || !item.toplists[0]) {
                        return null;
                    }
                    var list = item.toplists[0];
                    var image = (ref = list.description) === null || ref === void 0 ? void 0 : ref.find(function(d) {
                        return d.type === "image";
                    });
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: list.date,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.name,
                                type: types/* ContentTypes.TOPLIST_HEADLINE */.b.TOPLIST_HEADLINE,
                                url: item.url,
                                index: index
                            });
                        },
                        key: item.id,
                        likes: (ref1 = list.headlineInfo) === null || ref1 === void 0 ? void 0 : ref1.likes,
                        media: (image === null || image === void 0 ? void 0 : image.data) ? /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: image.data,
                            alt: list.title,
                            height: imageSize
                        }) : /*#__PURE__*/ react.createElement(ProductImages, {
                            height: "".concat(imageSize, "px"),
                            background: false,
                            selectedPosition: 2,
                            products: (ref2 = item.toplists[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.products) === null || ref3 === void 0 ? void 0 : ref3.map(function(p) {
                                return _objectSpread({}, p);
                            })
                        }),
                        titleAndCategory: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(badge/* Badge */.C, {
                            type: types/* ContentTypes.TOPLIST_HEADLINE */.b.TOPLIST_HEADLINE
                        }), ": ", item.name),
                        url: item.url,
                        footer: !hideExperts && list.expert.url ? /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            experts: [
                                list.expert
                            ].concat(_toConsumableArray((list === null || list === void 0 ? void 0 : (ref4 = list.headlineInfo) === null || ref4 === void 0 ? void 0 : ref4.otherExperts) || []))
                        }) : null
                    });
                }
            case types/* ContentTypes.TOPLIST */.b.TOPLIST:
                {
                    var ref5, ref6, ref7, ref8, ref9, ref10;
                    var ref11;
                    var imageUrl = (ref11 = (ref5 = item.image) === null || ref5 === void 0 ? void 0 : ref5.src) !== null && ref11 !== void 0 ? ref11 : (ref7 = (ref6 = item.description) === null || ref6 === void 0 ? void 0 : ref6.find(function(d) {
                        return d.type === "image";
                    })) === null || ref7 === void 0 ? void 0 : ref7.data;
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: item.date,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.TOPLIST */.b.TOPLIST,
                                url: item.headlineInfo.url,
                                index: index
                            });
                        },
                        key: item.id,
                        likes: (ref8 = item.headlineInfo) === null || ref8 === void 0 ? void 0 : ref8.likes,
                        media: imageUrl ? /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: imageUrl,
                            alt: item.title,
                            height: imageSize
                        }) : /*#__PURE__*/ react.createElement(ProductImages, {
                            height: "".concat(imageSize, "px"),
                            products: item.products.map(function(p) {
                                return _objectSpread({}, p);
                            }),
                            background: false
                        }),
                        titleAndCategory: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(badge/* Badge */.C, {
                            type: types/* ContentTypes.TOPLIST */.b.TOPLIST
                        }), ": ", item.title),
                        url: item.headlineInfo.url,
                        footer: !hideExperts && ((ref9 = item.expert) === null || ref9 === void 0 ? void 0 : ref9.url) ? /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            experts: [
                                item.expert
                            ].concat(_toConsumableArray(((ref10 = item.headlineInfo) === null || ref10 === void 0 ? void 0 : ref10.otherExperts) || []))
                        }) : null
                    });
                }
            case types/* ContentTypes.TEST */.b.TEST:
                {
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: item.date,
                        grade: item.gradeNotConverted !== undefined && /*#__PURE__*/ react.createElement(Rating, {
                            grade: item.gradeNotConverted
                        }),
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.TEST */.b.TEST,
                                url: item.url,
                                index: index
                            });
                        },
                        key: item.id,
                        likes: item.likes,
                        media: item.imageWithSize && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: item.imageWithSize.src,
                            alt: item.imageWithSize.alt,
                            height: imageSize
                        }),
                        titleAndCategory: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(badge/* Badge */.C, {
                            type: types/* ContentTypes.TEST */.b.TEST
                        }), ": ", item.title),
                        url: item.url,
                        footer: !hideExperts ? /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            experts: [
                                item.expert
                            ]
                        }) : null
                    });
                }
            case types/* ContentTypes.GUIDE */.b.GUIDE:
                {
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: item.date,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.GUIDE */.b.GUIDE,
                                url: item.url,
                                index: index
                            });
                        },
                        key: item.id,
                        likes: item.likes,
                        media: item.image && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: item.image.src,
                            alt: item.image.alt,
                            height: imageSize
                        }),
                        titleAndCategory: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(badge/* Badge */.C, {
                            type: types/* ContentTypes.GUIDE */.b.GUIDE
                        }), ": ", item.title),
                        url: item.url,
                        footer: !hideExperts ? /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            experts: [
                                item.expert
                            ]
                        }) : null
                    });
                }
            case types/* ContentTypes.ARTICLE */.b.ARTICLE:
                {
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: item.date,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.ARTICLE */.b.ARTICLE,
                                url: item.link,
                                index: index
                            });
                        },
                        key: item.id,
                        media: item.image && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: item.image.src,
                            alt: item.image.alt,
                            height: imageSize
                        }),
                        titleAndCategory: item.title,
                        url: item.link,
                        footer: /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            pointer: true,
                            experts: [
                                getDefaultExpert()
                            ]
                        }),
                        footerPartOfLink: true
                    });
                }
            case types/* ContentTypes.GENERIC_ARTICLE */.b.GENERIC_ARTICLE:
            case types/* ContentTypes.EDITORIAL_LANDING_PAGE */.b.EDITORIAL_LANDING_PAGE:
                {
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: dayjs_min_default()(item.date).format("DD MMMM YYYY"),
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.GENERIC_ARTICLE */.b.GENERIC_ARTICLE,
                                url: (0,utils/* getLinkByType */.ME)(item, linkTo) || "",
                                index: index
                            });
                        },
                        key: item.id,
                        media: item.thumbnail && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: item.thumbnail,
                            alt: item.thumbnailAlt || item.title,
                            height: imageSize
                        }),
                        titleAndCategory: item.title,
                        url: (0,utils/* getLinkByType */.ME)(item, linkTo),
                        footer: /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            pointer: true,
                            experts: [
                                getDefaultExpert()
                            ]
                        }),
                        footerPartOfLink: true
                    });
                }
            case types/* ContentTypes.VIDEO */.b.VIDEO:
                {
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.VIDEO */.b.VIDEO,
                                url: item.youtubeId,
                                index: index
                            });
                        },
                        key: item.id,
                        media: item.previewImage && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: item.previewImage,
                            alt: "",
                            height: 130
                        }),
                        videoMetadata: {
                            title: item.title,
                            thumbnail: item.previewImage,
                            videoId: item.youtubeId
                        },
                        titleAndCategory: item.title,
                        footer: /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            pointer: true,
                            experts: [
                                getPrismicExpert(item)
                            ]
                        }),
                        footerPartOfLink: true
                    });
                }
            default:
                return null;
        }
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, items.map(function(item, index) {
        if (!item || !item.id || !item.__typename) {
            return null;
        }
        if (index < offset || index >= numberOfCards) {
            return null;
        }
        return getContentCard(item, index);
    }));
};
/* harmony default export */ var list_of_content_cards = (ContentCards);


/***/ }),

/***/ 7102:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25349);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94141);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89218);
/* harmony import */ var _expert_avatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53973);
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57735);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    flex-flow: wrap;\n    gap: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  gap: ",
        ";\n  justify-content: start;\n  align-items: start;\n  width: 100%;\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 600;\n  margin-top: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: max-content;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  &:hover {\n    ",
        " {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  background: ",
        ";\n  border-radius: ",
        "px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 600;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}







var _measurements = src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements */ .bK.measurements, spacing025 = _measurements.spacing025, spacing100 = _measurements.spacing100;
var List = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "List",
    componentId: "sc-0-0"
})(_templateObject1(), spacing100, function(p) {
    return p.shouldWrap && "flex-flow: wrap;";
}, src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .media.largeUp */ .BC.largeUp(_templateObject(), spacing100));
var Name = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "Name",
    componentId: "sc-0-1"
})(_templateObject2(), spacing025, function(p) {
    return p.theme.text.primary;
});
var Expert = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "Expert",
    componentId: "sc-0-2"
})(_templateObject3());
var Clickable = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(src_components_clickable__WEBPACK_IMPORTED_MODULE_4__/* .Clickable */ .P).withConfig({
    displayName: "Clickable",
    componentId: "sc-0-3"
})(_templateObject4(), Name);
var Rest = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "Rest",
    componentId: "sc-0-4"
})(_templateObject5(), function(p) {
    return p.size;
}, function(p) {
    return p.size;
}, function(p) {
    return p.theme.icons.quaternary;
}, function(p) {
    return p.size;
});
var ListOfExperts = function(param) {
    var _avatarSize = param.avatarSize, avatarSize = _avatarSize === void 0 ? 64 : _avatarSize, className = param.className, count = param.count, experts = param.experts, _limit = param.limit, limit = _limit === void 0 ? 4 : _limit, _linkRest = param.linkRest, linkRest = _linkRest === void 0 ? false : _linkRest, _shouldWrap = param.shouldWrap, shouldWrap = _shouldWrap === void 0 ? false : _shouldWrap;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il), renderMode = ref.renderMode, linkTo = ref.linkTo;
    var restCount = count - limit;
    var renderRest = function() {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Expert, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Rest, {
            size: avatarSize
        }, "+", restCount));
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(List, {
        size: avatarSize,
        shouldWrap: shouldWrap,
        className: className,
        "data-test": "ListOfExperts"
    }, experts.slice(0, limit).map(function(expert, index) {
        if (!expert) return null;
        var children = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Expert, {
            key: expert.name
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_expert_avatar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            size: avatarSize,
            displayName: expert.name,
            avatar: expert.avatar
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Name, null, expert.name.split(" ")[0]));
        return expert.url ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Clickable, {
            key: expert.name,
            onClick: function() {
                return (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_6__/* .trackInternalNavigationClick */ .p)({
                    scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_6__/* .InternalNavigationScope.EXPERT_LIST_PROFILE_GO_TO */ .U.EXPERT_LIST_PROFILE_GO_TO,
                    nextPage: expert.url,
                    index: index
                });
            },
            isExternal: renderMode === "native",
            to: linkTo("expertProfile", {
                semantic_id: expert.url
            }, renderMode === "native" ? {
                view: "native"
            } : undefined)
        }, children) : children;
    }), restCount > 0 && (linkRest ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Clickable, {
        isExternal: renderMode === "native",
        to: linkTo("experts"),
        onClick: function() {
            return (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_6__/* .trackInternalNavigationClick */ .p)({
                scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_6__/* .InternalNavigationScope.EXPERT_LIST_EXPERT_PAGE_GO_TO */ .U.EXPERT_LIST_EXPERT_PAGE_GO_TO,
                nextPage: linkTo("experts"),
                index: limit
            });
        }
    }, renderRest()) : renderRest()));
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(ListOfExperts));


/***/ }),

/***/ 1946:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ rating)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/rating/rating-helper.ts
var rating_helper = __webpack_require__(51362);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(34990);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/star/index.js
var star = __webpack_require__(40000);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/expert/components/rating/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  font-weight: 600;\n  font-size: ",
        ";\n  line-height: 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: ",
        " ",
        ";\n  background: ",
        ";\n  border-radius: 20px;\n  justify-self: start;\n  font-weight: 600;\n  color: ",
        ";\n  line-height: 1;\n\n  svg {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 700;\n  font-size: ",
        ";\n  margin-left: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var _measurements = base/* layout.measurements */.bK.measurements, spacing025 = _measurements.spacing025, spacing050 = _measurements.spacing050;
var ExpertRating = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExpertRating",
    componentId: "sc-0-0"
})(_templateObject());
var Text = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Text",
    componentId: "sc-0-1"
})(_templateObject1(), spacing025, base/* layout.measurements.fontSizeMedium */.bK.measurements.fontSizeMedium);
var Badge = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Badge",
    componentId: "sc-0-2"
})(_templateObject2(), spacing025, spacing050, base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(base/* brandColors.expert */.D2.expert, 1), function(p) {
    return p.theme.colors.base0;
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var Stars = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Stars",
    componentId: "sc-0-3"
})(_templateObject3());
var RatingText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "RatingText",
    componentId: "sc-0-4"
})(_templateObject4(), base/* layout.measurements.fontSizeMedium */.bK.measurements.fontSizeMedium, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/badge/index.js
var badge = __webpack_require__(72321);
;// CONCATENATED MODULE: ./src/areas/expert/components/rating/index.tsx






var rating_ExpertRating = function(param) {
    var className = param.className, grade = param.grade, text = param.text, _as = param.as, as = _as === void 0 ? "badge" : _as;
    var rating = rating_helper/* default.toRoundedString */.Z.toRoundedString(grade);
    if (as === "stars") {
        return /*#__PURE__*/ react.createElement(Stars, {
            className: className
        }, /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
            rate: grade,
            expertColors: true,
            size: "large"
        }), " ", /*#__PURE__*/ react.createElement(RatingText, null, rating));
    }
    return /*#__PURE__*/ react.createElement(ExpertRating, {
        className: className
    }, text && /*#__PURE__*/ react.createElement(Text, null, text, ": "), /*#__PURE__*/ react.createElement(badge.Badge, {
        color: "BLUE_INVERTED",
        icon: star/* IconStar */.G,
        text: rating
    }));
};
/* harmony default export */ var rating = (rating_ExpertRating);


/***/ }),

/***/ 54712:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": () => (/* binding */ ExpertUserCardSize),
/* harmony export */   "b": () => (/* binding */ ContentTypes)
/* harmony export */ });
var ContentTypes;
(function(ContentTypes) {
    ContentTypes["TEST"] = "AdvizedTest";
    ContentTypes["TOPLIST"] = "AdvizedToplist";
    ContentTypes["TOPLIST_HEADLINE"] = "ToplistHeadline";
    ContentTypes["GUIDE"] = "ExpertGuide";
    ContentTypes["ARTICLE"] = "SearchArticleItem";
    ContentTypes["SPONSORED_ARTICLE"] = "SearchSponsoredArticle";
    ContentTypes["VIDEO"] = "SearchVideoItem";
    ContentTypes["GENERIC_ARTICLE"] = "SearchGenericArticle";
    ContentTypes["EDITORIAL_LANDING_PAGE"] = "SearchEditorialLandingPage";
})(ContentTypes || (ContentTypes = {}));
var ExpertUserCardSize;
(function(ExpertUserCardSize) {
    ExpertUserCardSize["SMALL"] = "SMALL";
    ExpertUserCardSize["MEDIUM"] = "MEDIUM";
})(ExpertUserCardSize || (ExpertUserCardSize = {}));


/***/ }),

/***/ 46674:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": () => (/* binding */ getTranslationByContentType),
/* harmony export */   "t": () => (/* binding */ compareByDate)
/* harmony export */ });
/* harmony import */ var src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54712);

/**
 * Compare function for sorting Adviced content in arrays
 */ var compareByDate = function(a, b) {
    // If null or undefined, move to bottom of list
    if (!a || !a.publishedAt) return 1;
    if (!b || !b.publishedAt) return -1;
    return parseInt(b.publishedAt, 10) - parseInt(a.publishedAt, 10);
};
var getTranslationByContentType = function(type, t) {
    switch(type){
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.TEST */ .b.TEST:
            return t("expert", "test.test");
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.TOPLIST */ .b.TOPLIST:
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.TOPLIST_HEADLINE */ .b.TOPLIST_HEADLINE:
            return t("expert", "toplist.toplist");
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.GUIDE */ .b.GUIDE:
            return t("expert", "guide.guide");
        default:
            return null;
    }
};


/***/ }),

/***/ 29200:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ getBannerDetails),
/* harmony export */   "u": () => (/* binding */ supportedCampaignIds)
/* harmony export */ });
/* harmony import */ var src_globals_helpers_campaign_campaign_ids__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26016);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var supportedCampaignIds = [
    src_globals_helpers_campaign_campaign_ids__WEBPACK_IMPORTED_MODULE_0__/* .CampaignIdEnum.BLACK_FRIDAY_ID */ .pw.BLACK_FRIDAY_ID,
    src_globals_helpers_campaign_campaign_ids__WEBPACK_IMPORTED_MODULE_0__/* .CampaignIdEnum.CHRISTMAS_SALE_ID */ .pw.CHRISTMAS_SALE_ID,
    src_globals_helpers_campaign_campaign_ids__WEBPACK_IMPORTED_MODULE_0__/* .CampaignIdEnum.CYBER_MONDAY_ID */ .pw.CYBER_MONDAY_ID
];
var getBannerDetails = function(market, t, isMobile, url) {
    var _obj;
    return _obj = {}, _defineProperty(_obj, src_globals_helpers_campaign_campaign_ids__WEBPACK_IMPORTED_MODULE_0__/* .CampaignEnum.BLACK_FRIDAY */ .MC.BLACK_FRIDAY, {
        badgeUrl: "".concat(market.cdn, "/g/campaigns/2/").concat(market.code, "/bf_banner_landing_page_big_").concat(isMobile ? "mobile" : "desktop", ".png")
    }), _defineProperty(_obj, src_globals_helpers_campaign_campaign_ids__WEBPACK_IMPORTED_MODULE_0__/* .CampaignEnum.CHRISTMAS_SALE */ .MC.CHRISTMAS_SALE, {
        badgeUrl: "".concat(market.cdn, "/g/campaigns/3/").concat(market.code, "/cs_banner_landing_page_big_").concat(isMobile ? "mobile" : "desktop", ".png")
    }), _defineProperty(_obj, src_globals_helpers_campaign_campaign_ids__WEBPACK_IMPORTED_MODULE_0__/* .CampaignEnum.CYBER_MONDAY */ .MC.CYBER_MONDAY, {
        badgeUrl: "".concat(market.cdn, "/g/campaigns/6/").concat(market.code, "/cm_banner_landing_page_big_").concat(isMobile ? "mobile" : "desktop", ".png")
    }), _defineProperty(_obj, "categoryLinks", [
        {
            name: t("campaigns", "campaign.bf-banner-landing-page-category-headphones"),
            link: "".concat(url, "?category=3004"),
            image: "".concat(market.cdn, "/g/campaigns/2/bf_banner_landing_page_big_category_headphones.png")
        },
        {
            name: t("campaigns", "campaign.bf-banner-landing-page-category-smartphones"),
            link: "".concat(url, "?category=103"),
            image: "".concat(market.cdn, "/g/campaigns/2/bf_banner_landing_page_big_category_smartphones.png")
        },
        {
            name: t("campaigns", "campaign.bf-banner-landing-page-category-tvs"),
            link: "".concat(url, "?category=107"),
            image: "".concat(market.cdn, "/g/campaigns/2/bf_banner_landing_page_big_category_tvs.png")
        },
        {
            name: t("campaigns", "campaign.bf-banner-landing-page-category-shoes"),
            link: "".concat(url, "?category=1490"),
            image: "".concat(market.cdn, "/g/campaigns/2/bf_banner_landing_page_big_category_shoes.png")
        },
        {
            name: t("campaigns", "campaign.bf-banner-landing-page-category-perfumes"),
            link: "".concat(url, "?category=965"),
            image: "".concat(market.cdn, "/g/campaigns/2/bf_banner_landing_page_big_category_perfumes.png")
        },
        {
            name: t("campaigns", "campaign.bf-banner-landing-page-category-kitchen"),
            link: "".concat(url, "?category=1671"),
            image: "".concat(market.cdn, "/g/campaigns/2/bf_banner_landing_page_big_category_kitchen.png")
        }
    ]), _obj;
};


/***/ }),

/***/ 79436:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
/* harmony import */ var src_globals_helpers_campaign_campaign_ids__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26016);
/* harmony import */ var _campaign_banner_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29200);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}




var BannerComponentLegacy = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "campaigns";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | campaigns */ 340).then(__webpack_require__.bind(__webpack_require__, 787));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(787);
        }
        return eval("require.resolve")("./campaign-banner-legacy");
    }
});
var BannerComponent = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "campaigns";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | campaigns */ 340).then(__webpack_require__.bind(__webpack_require__, 81491));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(81491);
        }
        return eval("require.resolve")("./campaign-banner");
    }
});
var CampaignBannerLoader = function(props) {
    return props.activeId && _campaign_banner_utils__WEBPACK_IMPORTED_MODULE_3__/* .supportedCampaignIds.includes */ .u.includes(props.activeId) ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BannerComponent, {
        activeCampaign: (0,src_globals_helpers_campaign_campaign_ids__WEBPACK_IMPORTED_MODULE_2__/* .mapCampaignIdToName */ .k1)(props.activeId),
        altText: props.badgeAltText,
        url: props.url
    }) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BannerComponentLegacy, _extends({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (CampaignBannerLoader);


/***/ }),

/***/ 92936:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ featured_article)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/lazy/index.tsx
var lazy = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
;// CONCATENATED MODULE: ./src/areas/landing-page/components/featured-article/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    padding-top: 4px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    flex-direction: row;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    padding-right: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: stretch;\n  flex-direction: column;\n\n  /* Add extra spacing to panel header which has 12px - Should be 24 in desktop and 16 on mobile */\n  padding-top: 12px;\n  ",
        ";\n\n  ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n\n    > span {\n      flex-grow: 0;\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    flex-basis: 60%;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    margin-bottom: ",
        ";\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    flex-basis: 40%;\n    max-width: 300px;\n    padding-right: ",
        ";\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n  position: relative;\n  min-height: 170px;\n\n  ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var FeaturedArticle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FeaturedArticle",
    componentId: "sc-0-0"
})(_templateObject3(), base/* media.smallOnly */.BC.smallOnly(_templateObject()), base/* media.mediumUp */.BC.mediumUp(_templateObject1()), base/* media.showOutsiderAd */.BC.showOutsiderAd(_templateObject2(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025));
var ArticleLink = (0,styled_components_browser_esm["default"])(variants.OutlinedButton).withConfig({
    displayName: "ArticleLink",
    componentId: "sc-0-1"
})(_templateObject5(), base/* media.smallOnly */.BC.smallOnly(_templateObject4()));
var TextContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TextContainer",
    componentId: "sc-0-2"
})(_templateObject7(), base/* media.mediumUp */.BC.mediumUp(_templateObject6()));
var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ImageWrapper",
    componentId: "sc-0-3"
})(_templateObject10(), base/* media.smallOnly */.BC.smallOnly(_templateObject8(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100), base/* media.mediumUp */.BC.mediumUp(_templateObject9(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150));

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/areas/landing-page/components/featured-article/index.tsx





var featured_article_FeaturedArticle = function(param) {
    var className = param.className, imageUrl = param.imageUrl, pathName = param.pathName, preamble = param.preamble, title = param.title, linkText = param.linkText;
    var renderArticleLink = function() {
        if (!linkText) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(ArticleLink, {
            container: "a",
            containerProps: {
                href: pathName
            },
            onClick: function() {
                return (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.ARTICLE_READ_MORE */.U.ARTICLE_READ_MORE,
                    nextPage: pathName
                });
            }
        }, linkText);
    };
    return /*#__PURE__*/ react.createElement(FeaturedArticle, {
        className: className
    }, imageUrl && /*#__PURE__*/ react.createElement(ImageWrapper, null, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
        loadOnIdle: true
    }, /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: pathName,
        onClick: function() {
            (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.ARTICLE_CONTENT_CARD */.U.ARTICLE_CONTENT_CARD,
                nextPage: pathName
            });
        }
    }, /*#__PURE__*/ react.createElement("img", {
        src: imageUrl,
        alt: ""
    })))), /*#__PURE__*/ react.createElement(TextContainer, null, /*#__PURE__*/ react.createElement("h3", null, /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: pathName
    }, title)), /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: pathName,
        onClick: function() {
            return (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.ARTICLE_READ_MORE */.U.ARTICLE_READ_MORE,
                nextPage: pathName
            });
        }
    }, /*#__PURE__*/ react.createElement("p", null, preamble)), renderArticleLink()));
};
/* harmony default export */ var featured_article = (featured_article_FeaturedArticle);


/***/ }),

/***/ 58413:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71297);

var PopularFacetsLoader = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "popular-facets";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | popular-facets */ 159).then(__webpack_require__.bind(__webpack_require__, 74904));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(74904);
        }
        return eval("require.resolve")("./popular-facets-sections");
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (PopularFacetsLoader);


/***/ }),

/***/ 60166:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ landing_page)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/list/variants.js
var variants = __webpack_require__(29261);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(79393);
;// CONCATENATED MODULE: ./src/areas/landing-page/filter-categories.ts
// Filter products and remove products from categories that the user is not
// interested in.
var filterCategories = function(products) {
    return products.filter(function(p) {
        return p === null || p === void 0 ? void 0 : p.category;
    });
};

// EXTERNAL MODULE: ./src/components/cards-carousel/index.tsx + 7 modules
var cards_carousel = __webpack_require__(49601);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./src/components/cards-carousel/carousel-context.tsx
var carousel_context = __webpack_require__(74650);
;// CONCATENATED MODULE: ./src/components/featured-products/index.tsx





var FeaturedProducts = function(props) {
    var featuredProducts = props.featuredProducts;
    if (!featuredProducts) return null;
    var featuredProductsItems = filterCategories(featuredProducts.products);
    var linkPath = function() {
        if (!featuredProducts.linkUrl) return undefined;
        try {
            // linkUrl is a URL
            var fullURL = featuredProducts.linkUrl.startsWith("www") ? "https://".concat(featuredProducts.linkUrl) : featuredProducts.linkUrl;
            var linkUrl = new URL(fullURL);
            return linkUrl.pathname + linkUrl.search;
        } catch (e) {
            // linkUrl is a path
            return featuredProducts.linkUrl;
        }
    };
    var trackHeaderClick = function(data) {
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.FEATURED_PRODUCTS_HEADER */.U.FEATURED_PRODUCTS_HEADER,
            nextPage: data.link
        });
    };
    var trackProductCardClick = function(data) {
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.FEATURED_PRODUCTS_PRODUCTS_CARD */.U.FEATURED_PRODUCTS_PRODUCTS_CARD,
            nextPage: data.link,
            index: data.index
        });
    };
    return /*#__PURE__*/ react.createElement(carousel_context/* CarouselContextContainer */.L, {
        items: featuredProductsItems,
        linkPath: linkPath(),
        linkTitle: featuredProducts.linkTitle ? featuredProducts.linkTitle : undefined,
        negativeMargin: props.negativeMargin,
        onHeaderLinkClick: trackHeaderClick,
        onCardClick: trackProductCardClick,
        title: featuredProducts.title ? featuredProducts.title : ""
    }, /*#__PURE__*/ react.createElement(cards_carousel/* CardsCarousel */.T, null));
};
/* harmony default export */ var featured_products = (FeaturedProducts);

// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(62619);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(12321);
// EXTERNAL MODULE: ./src/areas/product/actions/product.ts + 1 modules
var product = __webpack_require__(69140);
// EXTERNAL MODULE: ./src/globals/helpers/navigation-action.js
var navigation_action = __webpack_require__(83104);
// EXTERNAL MODULE: ./src/hooks/use-gql-query.ts
var use_gql_query = __webpack_require__(27019);
// EXTERNAL MODULE: ./src/components/trending-products/query.graphql
var query_graphql = __webpack_require__(13707);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
;// CONCATENATED MODULE: ./src/components/trending-products/index.tsx











var TrendingProducts = function(props) {
    var ref, ref1;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var result = (0,use_gql_query/* useGqlQuery */.n)({
        query: (query_graphql_default()),
        queryKey: [
            "trendingProducts"
        ]
    });
    var trendingProducts = (ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.trendingProducts) === null || ref1 === void 0 ? void 0 : ref1.trendingProducts;
    if (!(trendingProducts && trendingProducts.nodes) || !trendingProducts.nodes.length) {
        return null;
    }
    var trendingProductsItems = filterCategories(trendingProducts.nodes);
    var trackHeaderClick = function(data) {
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.TRENDING_PRODUCTS */.U.TRENDING_PRODUCTS,
            nextPage: data.link
        });
    };
    var trackProductCardClick = function(data) {
        dispatch((0,product/* productNavigation */.$0)(navigation_action/* TRENDING_PRODUCT_CLICK */.fT, data.index + 1));
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.TRENDING_PRODUCTS */.U.TRENDING_PRODUCTS,
            nextPage: data.link,
            index: data.index
        });
    };
    return /*#__PURE__*/ react.createElement(carousel_context/* CarouselContextContainer */.L, {
        items: trendingProductsItems,
        negativeMargin: props.negativeMargin,
        onHeaderLinkClick: trackHeaderClick,
        onCardClick: trackProductCardClick,
        shouldLazyLoadImages: true,
        title: t("landing", "trending-products.title")
    }, /*#__PURE__*/ react.createElement(cards_carousel/* CardsCarousel */.T, null));
};
/* harmony default export */ var trending_products = (TrendingProducts);

// EXTERNAL MODULE: ./src/components/campaign-banners/promo-banner/index.tsx + 2 modules
var promo_banner = __webpack_require__(38911);
// EXTERNAL MODULE: ./src/components/campaign-deals/index.ts
var campaign_deals = __webpack_require__(87341);
// EXTERNAL MODULE: ./src/components/recently-visited/index.ts
var recently_visited = __webpack_require__(24068);
// EXTERNAL MODULE: ./src/areas/landing-page/components/campaign-banner/index.tsx
var campaign_banner = __webpack_require__(79436);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/horizontal-scroll/index.tsx + 1 modules
var horizontal_scroll = __webpack_require__(75081);
// EXTERNAL MODULE: ./src/components/list-item/index.tsx
var list_item = __webpack_require__(91441);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/search/components/link-suggestions/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: underline;\n  font-weight: 600;\n  margin-left: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: rgba(255, 255, 255, 0.72);\n  font-weight: 600;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 900px;\n  flex-basis: 100%;\n  margin-top: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n  color: ",
        "; /* For ellipsis color */\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  text-decoration: underline;\n  color: ",
        ";\n  &:hover {\n    background-color: inherit;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var StyledLink = styled_components_browser_esm["default"].a.withConfig({
    displayName: "StyledLink",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.colors.base0;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledSpan = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledSpan",
    componentId: "sc-0-1"
})(_templateObject1());
var Box = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Box",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(p) {
    return p.theme.colors.base0;
});
var ListItem = (0,styled_components_browser_esm["default"])(list_item/* ListItem */.H).withConfig({
    displayName: "ListItem",
    componentId: "sc-0-3"
})(_templateObject3(), function(p) {
    return p.theme.colors.base0;
});
var HorizontalScroll = (0,styled_components_browser_esm["default"])(horizontal_scroll/* HorizontalScroll */.Z).withConfig({
    displayName: "HorizontalScroll",
    componentId: "sc-0-4"
})(_templateObject4(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075);

// EXTERNAL MODULE: ./src/components/text-link/index.tsx + 1 modules
var text_link = __webpack_require__(30943);
// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(22899);
// EXTERNAL MODULE: ./src/areas/expert/components/list-of-experts/index.tsx
var list_of_experts = __webpack_require__(7102);
// EXTERNAL MODULE: ./src/areas/expert/components/list-of-content-cards/index.tsx + 2 modules
var list_of_content_cards = __webpack_require__(8263);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(99816);
;// CONCATENATED MODULE: ./src/areas/landing-page/components/experts/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-rows: 1fr auto;\n  row-gap: ",
        ";\n  margin-top: ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    row-gap: ",
        ";\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 50% auto ",
        ";\n  column-gap: ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n\n  > :not(:last-child) {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n    justify-content: flex-start;\n      margin-bottom: ",
        ";\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: flex-end;\n\n    ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  row-gap: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n    grid-template-columns: repeat(4, minmax(250px, 1fr));\n    \n\n    &::after {\n      // Adds spacing to the end of the scroll area\n      content: '';\n      display: block;\n      width: 1px;\n      margin-left: -",
        ";\n      pointer-events: none;\n    }\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  column-gap: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin: 1px;\n\n  a {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  row-gap: ",
        ";\n  line-height: 1.5;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n    width: 100%;\n    grid-template-columns: unset;\n    grid-auto-flow: column;\n    justify-content: flex-start;\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n\n  ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = styles_taggedTemplateLiteral([
        "\n    display: block;\n  "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = styles_taggedTemplateLiteral([
        "\n      display: none;\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n\n  ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = styles_taggedTemplateLiteral([
        "\n      display: flex;\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = styles_taggedTemplateLiteral([
        "\n      width: calc(100vw - ",
        ");\n\n      > span {\n        flex-grow: 0;\n      }\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}





var ExpertSection = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExpertSection",
    componentId: "sc-0-0"
})(styles_templateObject1(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.mediumDown */.BC.mediumDown(styles_templateObject()));
var Section = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Section",
    componentId: "sc-0-1"
})(styles_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.mediumDown */.BC.mediumDown(styles_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var Main = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Main",
    componentId: "sc-0-2"
})(styles_templateObject4(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ExpertList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExpertList",
    componentId: "sc-0-3"
})(function() {
    return (0,styled_components_browser_esm.css)(_templateObject6(), base/* media.mediumDown */.BC.mediumDown(_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
});
var List = styled_components_browser_esm["default"].div.withConfig({
    displayName: "List",
    componentId: "sc-0-4"
})(_templateObject7(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ContentList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ContentList",
    componentId: "sc-0-5"
})(_templateObject9(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.mediumDown */.BC.mediumDown(_templateObject8(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var ContentCards = (0,styled_components_browser_esm["default"])(list_of_content_cards/* default */.Z).withConfig({
    displayName: "ContentCards",
    componentId: "sc-0-6"
})(_templateObject10(), function(p) {
    return p.theme.text.primary;
});
var Description = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Description",
    componentId: "sc-0-7"
})(_templateObject11(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ListOfExperts = (0,styled_components_browser_esm["default"])(list_of_experts/* default */.Z).withConfig({
    displayName: "ListOfExperts",
    componentId: "sc-0-8"
})(_templateObject13(), base/* media.mediumDown */.BC.mediumDown(_templateObject12()));
var ButtonDesktop = (0,styled_components_browser_esm["default"])(ui_button.Button).withConfig({
    displayName: "ButtonDesktop",
    componentId: "sc-0-9"
})(_templateObject16(), base/* media.largeUp */.BC.largeUp(_templateObject14()), base/* media.mediumDown */.BC.mediumDown(_templateObject15()));
var ButtonMobile = (0,styled_components_browser_esm["default"])(ui_button.Button).withConfig({
    displayName: "ButtonMobile",
    componentId: "sc-0-10"
})(_templateObject20(), base/* media.largeUp */.BC.largeUp(_templateObject17()), base/* media.mediumDown */.BC.mediumDown(_templateObject18()), base/* media.smallOnly */.BC.smallOnly(_templateObject19(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));

;// CONCATENATED MODULE: ./src/areas/landing-page/components/experts/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








var experts_ExpertSection = function(param) {
    var data = param.data;
    var ref, ref1;
    var ref2 = (0,react.useContext)(app_context/* AppContext */.Il), t = ref2.t, market = ref2.market, linkTo = ref2.linkTo;
    var isDesktop = (0,react.useContext)(viewport/* ViewportContext */.R).isDesktop;
    if (!(data === null || data === void 0 ? void 0 : data.items)) return null;
    var _items = data.items, tests = _items.tests, toplists = _items.toplists;
    var experts = data.experts, expertCount = data.expertCount;
    var articleUrl = (ref = market.articles) === null || ref === void 0 ? void 0 : (ref1 = ref.aboutExperts) === null || ref1 === void 0 ? void 0 : ref1.path;
    var content = _toConsumableArray(tests).concat(_toConsumableArray(toplists));
    var expertsPage = linkTo("experts");
    return /*#__PURE__*/ react.createElement(ExpertSection, null, /*#__PURE__*/ react.createElement(Section, null, /*#__PURE__*/ react.createElement(Main, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(text_variants.TitleMediumText, null, t("expert", "promo.advice")), /*#__PURE__*/ react.createElement(text_variants.H2Text, null, t("expert", "expert.brand-name"))), /*#__PURE__*/ react.createElement(Description, null, /*#__PURE__*/ react.createElement("div", null, t("expert", "entry.promo-text"), " "), articleUrl && /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(text_link/* TextLink */.h, {
        to: articleUrl,
        onClick: function() {
            if (articleUrl) {
                (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.EXPERT_INDEPENDENT_GUARANTEE */.U.EXPERT_INDEPENDENT_GUARANTEE,
                    nextPage: articleUrl
                });
            }
        }
    }, t("expert", "entry.link-to-article-text")))), /*#__PURE__*/ react.createElement(ButtonDesktop, {
        container: "a",
        containerProps: {
            href: expertsPage
        },
        onClick: function() {
            return (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.EXPERT_PAGE_GO_TO */.U.EXPERT_PAGE_GO_TO,
                nextPage: expertsPage
            });
        }
    }, t("expert", "entry.latest-link"))), /*#__PURE__*/ react.createElement(ExpertList, null, /*#__PURE__*/ react.createElement(HorizontalScroll, {
        showArrows: false
    }, /*#__PURE__*/ react.createElement(ListOfExperts, {
        experts: experts,
        count: expertCount || 0,
        limit: 9,
        linkRest: true
    }))), /*#__PURE__*/ react.createElement(ButtonMobile, {
        container: "a",
        containerProps: {
            href: expertsPage
        },
        onClick: function() {
            return (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.EXPERT_PAGE_GO_TO */.U.EXPERT_PAGE_GO_TO,
                nextPage: expertsPage
            });
        }
    }, t("expert", "entry.latest-link"))), /*#__PURE__*/ react.createElement(List, null, /*#__PURE__*/ react.createElement(text_variants.TitleMediumText, null, t("expert", "entry.latest-title")), /*#__PURE__*/ react.createElement(HorizontalScroll, {
        showArrows: !isDesktop && content.length > 1
    }, /*#__PURE__*/ react.createElement(ContentList, null, /*#__PURE__*/ react.createElement(ContentCards, {
        items: content,
        limit: 4
    })))));
};
/* harmony default export */ var experts = (experts_ExpertSection);

// EXTERNAL MODULE: ./src/areas/landing-page/components/featured-article/index.tsx + 1 modules
var featured_article = __webpack_require__(92936);
// EXTERNAL MODULE: ./packages/react-ads/dist/module.js + 1 modules
var dist_module = __webpack_require__(6895);
// EXTERNAL MODULE: ./src/components/category-list/index.tsx + 8 modules
var category_list = __webpack_require__(97963);
;// CONCATENATED MODULE: ./src/areas/landing-page/styles.ts
function landing_page_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function landing_page_styles_templateObject() {
    var data = landing_page_styles_taggedTemplateLiteral([
        "\n  min-height: 1100px; /* HACK: IE11 cant calculate height of this page, fix this when */\n"
    ]);
    landing_page_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function landing_page_styles_templateObject1() {
    var data = landing_page_styles_taggedTemplateLiteral([
        "\n    margin-top: 20px;\n    margin-bottom: 20px;\n  "
    ]);
    landing_page_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function landing_page_styles_templateObject2() {
    var data = landing_page_styles_taggedTemplateLiteral([
        "\n    margin-top: 0px;\n    margin-bottom: 20px;\n  "
    ]);
    landing_page_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function landing_page_styles_templateObject3() {
    var data = landing_page_styles_taggedTemplateLiteral([
        "\n  margin-top: 30px;\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    landing_page_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function landing_page_styles_templateObject4() {
    var data = landing_page_styles_taggedTemplateLiteral([
        "\n    /* The negative margin are for the border bottom to go all the way to the edge on mobile.*/\n    margin-left: -",
        ";\n    margin-right: -",
        ";\n  "
    ]);
    landing_page_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = landing_page_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = landing_page_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  margin-top: ",
        ";\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = landing_page_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var Root = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Root",
    componentId: "sc-0-0"
})(landing_page_styles_templateObject());
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-1"
})(landing_page_styles_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumOnly */.BC.mediumOnly(landing_page_styles_templateObject1()), base/* media.smallDown */.BC.smallDown(landing_page_styles_templateObject2()));
var CategoryList = (0,styled_components_browser_esm["default"])(category_list/* CategoryList */.o).withConfig({
    displayName: "CategoryList",
    componentId: "sc-0-2"
})(styles_templateObject5(), base/* media.smallOnly */.BC.smallOnly(landing_page_styles_templateObject4(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var AdPlacementMarginTop = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AdPlacementMarginTop",
    componentId: "sc-0-3"
})(styles_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var AdPlacementMarginY = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AdPlacementMarginY",
    componentId: "sc-0-4"
})(styles_templateObject7(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/landing-page/components/featured-article/landing-page-article.tsx






var LandingPageFeaturedArticles = function(props) {
    var articles = props.articles, showAd = props.showAd;
    var t = (0,app_context/* useAppContext */.bp)().t;
    if (articles.length === 0) return null;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, articles.map(function(article, index) {
        var ArticleComponent = /*#__PURE__*/ react.createElement(panel/* Panel */.s_, {
            key: article.id
        }, /*#__PURE__*/ react.createElement(featured_article/* default */.Z, {
            pathName: article.pathName,
            imageUrl: article.imageUrl,
            title: article.title,
            preamble: article.description,
            linkText: t("landing", "featured-article.read-more")
        }));
        if (showAd && index === 0) {
            return /*#__PURE__*/ react.createElement(react.Fragment, {
                key: "ad-container"
            }, ArticleComponent, /*#__PURE__*/ react.createElement(AdPlacementMarginTop, null, /*#__PURE__*/ react.createElement(dist_module/* AdPlacement */.ZD, {
                format: "panorama_1",
                triggerPoint: 0
            })));
        }
        return ArticleComponent;
    }));
};

;// CONCATENATED MODULE: ./src/components/new-product-releases/index.tsx









var NewProductReleases = function(props) {
    var tmp = props.newReleases, newProducts = tmp === void 0 ? [] : tmp, negativeMargin = props.negativeMargin;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var dispatch = (0,es/* useDispatch */.I0)();
    if (!newProducts || !newProducts.length) {
        return null;
    }
    var newProductsItems = filterCategories(newProducts);
    var trackHeaderClick = function(data) {
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.NEW_PRODUCT_RELEASES_HEADER */.U.NEW_PRODUCT_RELEASES_HEADER,
            nextPage: data.link
        });
    };
    var trackProductCardClick = function(data) {
        dispatch((0,product/* productNavigation */.$0)(navigation_action/* NEW_PRODUCT_CLICK */.DE, data.index + 1));
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.NEW_PRODUCT_RELEASES_PRODUCT_CARD */.U.NEW_PRODUCT_RELEASES_PRODUCT_CARD,
            nextPage: data.link,
            index: data.index
        });
    };
    return /*#__PURE__*/ react.createElement(carousel_context/* CarouselContextContainer */.L, {
        items: newProductsItems,
        negativeMargin: negativeMargin,
        onHeaderLinkClick: trackHeaderClick,
        onCardClick: trackProductCardClick,
        shouldLazyLoadImages: true,
        title: t("landing", "personalized-releases.title")
    }, /*#__PURE__*/ react.createElement(cards_carousel/* CardsCarousel */.T, null));
};
/* harmony default export */ var new_product_releases = (NewProductReleases);

// EXTERNAL MODULE: ./src/areas/landing-page/components/new-products/query.graphql
var new_products_query_graphql = __webpack_require__(23920);
var new_products_query_graphql_default = /*#__PURE__*/__webpack_require__.n(new_products_query_graphql);
;// CONCATENATED MODULE: ./src/areas/landing-page/components/new-products/index.tsx




var NewProducts = function() {
    var ref, ref1, ref2;
    var result = (0,use_gql_query/* useGqlQuery */.n)({
        query: (new_products_query_graphql_default()),
        queryKey: [
            "newProducts"
        ]
    });
    var newReleases = (ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.newProductRecommendations) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.newReleases) === null || ref2 === void 0 ? void 0 : ref2.nodes;
    if (result.isError || !newReleases) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(new_product_releases, {
        negativeMargin: true,
        newReleases: newReleases
    });
};

// EXTERNAL MODULE: ./src/areas/landing-page/components/popular-facets/index.tsx
var popular_facets = __webpack_require__(58413);
// EXTERNAL MODULE: ./src/areas/landing-page/components/popular-products/query.graphql
var popular_products_query_graphql = __webpack_require__(6281);
var popular_products_query_graphql_default = /*#__PURE__*/__webpack_require__.n(popular_products_query_graphql);
;// CONCATENATED MODULE: ./src/areas/landing-page/components/popular-products/index.tsx











var PopularProducts = function(props) {
    var ref, ref1;
    var ref2 = (0,react.useContext)(app_context/* AppContext */.Il), t = ref2.t, linkTo = ref2.linkTo;
    var dispatch = (0,es/* useDispatch */.I0)();
    var result = (0,use_gql_query/* useGqlQuery */.n)({
        query: (popular_products_query_graphql_default()),
        queryKey: [
            "popular-products"
        ]
    });
    var products = (ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.category) === null || ref1 === void 0 ? void 0 : ref1.products;
    if (result.isError || !(products && products.nodes) || !products.nodes.length) {
        return null;
    }
    var productsItems = filterCategories(products.nodes);
    var internalLinkTo = linkTo("virtualCategory", {
        id: "v100"
    });
    var trackHeaderClick = function(data) {
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.POPULAR_PRODUCTS_LANDINGPAGE_HEADER */.U.POPULAR_PRODUCTS_LANDINGPAGE_HEADER,
            nextPage: data.link
        });
    };
    var trackProductCardClick = function(data) {
        if (data.index) dispatch((0,product/* productNavigation */.$0)(navigation_action/* POPULAR_CLICK */.LT, data.index + 1));
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.POPULAR_PRODUCTS_LANDINGPAGE_PRODUCT_CARD */.U.POPULAR_PRODUCTS_LANDINGPAGE_PRODUCT_CARD,
            nextPage: data.link,
            index: data.index
        });
    };
    return /*#__PURE__*/ react.createElement(carousel_context/* CarouselContextContainer */.L, {
        items: productsItems,
        linkPath: internalLinkTo,
        linkTitle: t("common", "button.show-all-popular-products"),
        negativeMargin: props.negativeMargin,
        onHeaderLinkClick: trackHeaderClick,
        onCardClick: trackProductCardClick,
        shouldLazyLoadImages: true,
        title: t("landing", "hot-products.title")
    }, /*#__PURE__*/ react.createElement(cards_carousel/* CardsCarousel */.T, null));
};
/* harmony default export */ var popular_products = (PopularProducts);

// EXTERNAL MODULE: ./src/areas/search-suggestions/history-storage.tsx
var history_storage = __webpack_require__(81118);
;// CONCATENATED MODULE: ./src/areas/search/components/link-suggestions/index.tsx



var LinkSuggestions = function(param) {
    var title = param.title, suggestions = param.suggestions, onLinkClick = param.onLinkClick;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    if (!suggestions.length) return null;
    var renderRecentSearches = function() {
        /*#__PURE__*/ return react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(StyledSpan, null, title), suggestions.map(function(suggestion) {
            return /*#__PURE__*/ react.createElement(StyledLink, {
                href: suggestion.url,
                key: suggestion.url,
                onClick: function() {
                    return onLinkClick === null || onLinkClick === void 0 ? void 0 : onLinkClick(suggestion);
                }
            }, suggestion.title);
        }));
    };
    var renderMobile = function() {
        return /*#__PURE__*/ react.createElement(HorizontalScroll, {
            showArrows: false
        }, renderRecentSearches());
    };
    var renderDesktop = function() {
        return /*#__PURE__*/ react.createElement(Box, null, renderRecentSearches());
    };
    return isMobile ? renderMobile() : renderDesktop();
};

// EXTERNAL MODULE: ./src/components/search-bar/index.tsx + 19 modules
var search_bar = __webpack_require__(87316);
// EXTERNAL MODULE: ./src/hooks/useEffectOnMount.ts
var useEffectOnMount = __webpack_require__(66050);
;// CONCATENATED MODULE: ./src/areas/landing-page/components/search-hero/style.ts
function style_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function style_templateObject() {
    var data = style_taggedTemplateLiteral([
        "\n    height: auto;\n    padding:\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        ";\n    margin-top: 0;\n    background-color: ",
        ";\n  "
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function style_templateObject1() {
    var data = style_taggedTemplateLiteral([
        "\n      margin-top: 0;\n      max-width: unset;\n    "
    ]);
    style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function style_templateObject2() {
    var data = style_taggedTemplateLiteral([
        "\n    background-image: url(",
        ");\n  "
    ]);
    style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function style_templateObject3() {
    var data = style_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 980px;\n  height: 234px;\n  display: flex;\n  justify-content: center;\n  background-size: cover;\n  background-position: center;\n  margin: auto;\n  padding: ",
        ";\n  margin-top: ",
        ";\n  flex-wrap: wrap;\n\n  ",
        "\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function style_templateObject4() {
    var data = style_taggedTemplateLiteral([
        "\n    ",
        "}\n  "
    ]);
    style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function style_templateObject5() {
    var data = style_taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  max-width: 500px;\n  color: ",
        ";\n  ",
        "\n"
    ]);
    style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function style_templateObject6() {
    var data = style_taggedTemplateLiteral([
        "\n  top: 0;\n  z-index: 108;\n"
    ]);
    style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function style_templateObject7() {
    var data = style_taggedTemplateLiteral([
        "\n    white-space: initial;\n  "
    ]);
    style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function style_templateObject8() {
    var data = style_taggedTemplateLiteral([
        "\n  white-space: pre;\n  text-align: center;\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    style_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var Hero = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Hero",
    componentId: "sc-0-0"
})(style_templateObject3(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return base/* media.smallOnly */.BC.smallOnly(style_templateObject(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, p.$hasLinkSuggestions ? base/* layout.measurements.spacing100 */.bK.measurements.spacing100 : base/* layout.measurements.spacing300 */.bK.measurements.spacing300, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, p.$isBlackFriday ? "#0D1F2A" : p.theme.colors.maybeBlue500);
}, function(p) {
    return !p.$active ? "height: 0; overflow: hidden;" : "";
}, function(p) {
    return p.$fullWidth && (0,styled_components_browser_esm.css)(style_templateObject1());
}, function(p) {
    return base/* media.mediumUp */.BC.mediumUp(style_templateObject2(), p.$backgroundImage);
});
var style_Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-1"
})(style_templateObject5(), function(p) {
    return p.theme.colors.base0;
}, function(p) {
    return base/* media.mediumUp */.BC.mediumUp(style_templateObject4(), "margin-top: ".concat(base/* layout.measurements.spacing050 */.bK.measurements.spacing050, ";"));
});
var SearchWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchWrapper",
    componentId: "sc-0-2"
})(style_templateObject6());
var HeroTitle = (0,styled_components_browser_esm["default"])(text_variants.H1Text).withConfig({
    displayName: "HeroTitle",
    componentId: "sc-0-3"
})(style_templateObject8(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(style_templateObject7()));

// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(84234);
;// CONCATENATED MODULE: ./src/areas/landing-page/components/search-hero/search-hero.tsx
function search_hero_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || search_hero_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function search_hero_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return search_hero_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return search_hero_arrayLikeToArray(o, minLen);
}









var SearchHero = function(param) {
    var _active = param.active, active = _active === void 0 ? true : _active;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), market = ref.market, t = ref.t;
    var linkSuggestions = useLinkSuggestions();
    var backgroundImage = "".concat(market.cdn, "/g/rfe/illustrations/search-hero-background-2000x468.png");
    var dateEnd = new Date("2024-12-01T11:00:00Z"); // Black Friday end date in UTC (12:00 swedish time)
    var currentTime = new Date();
    var heroTitle = t("landing", "hero.title");
    if (currentTime < dateEnd) {
        heroTitle = t("landing", "hero.title-black-friday");
        backgroundImage = "".concat(market.cdn, "/g/rfe/illustrations/search-hero-background-bf@2x.png");
    }
    return /*#__PURE__*/ react.createElement(block/* MobileOnly */.iB, null, /*#__PURE__*/ react.createElement(Hero, {
        $active: active,
        $backgroundImage: backgroundImage,
        $fullWidth: false,
        $hasLinkSuggestions: !!linkSuggestions,
        $isBlackFriday: currentTime < dateEnd,
        "data-test": "hero-search"
    }, /*#__PURE__*/ react.createElement(style_Content, null, /*#__PURE__*/ react.createElement(HeroTitle, null, heroTitle), /*#__PURE__*/ react.createElement(SearchWrapper, null, /*#__PURE__*/ react.createElement(search_bar/* SearchBar */.E, {
        placement: "hero"
    }))), linkSuggestions ? /*#__PURE__*/ react.createElement(LinkSuggestions, {
        title: linkSuggestions.title,
        suggestions: linkSuggestions.links,
        onLinkClick: linkSuggestions.onLinkClick
    }) : null));
};
/**
 * Determines which link suggestions to show in the hero.
 */ function useLinkSuggestions() {
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = _slicedToArray((0,react.useState)([]), 2), recentSearches = ref[0], setRecentSearches = ref[1];
    (0,useEffectOnMount/* useEffectOnMount */.O)(function() {
        setRecentSearches((0,history_storage/* getRecentSearches */.KM)());
    });
    if (recentSearches.length) {
        return {
            title: t("search", "search.your-searches"),
            links: recentSearches.map(function(s) {
                return {
                    url: "/search?query=".concat(encodeURIComponent(s)),
                    title: s
                };
            }),
            onLinkClick: function onLinkClick(suggestion) {
                (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.HERO_BANNER */.U.HERO_BANNER,
                    nextPage: suggestion.url
                });
            }
        };
    }
    return null;
}

;// CONCATENATED MODULE: ./src/areas/landing-page/components/search-hero/index.ts


// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(42281);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(48458);
// EXTERNAL MODULE: ./src/areas/landing-page/query.graphql
var landing_page_query_graphql = __webpack_require__(77166);
var landing_page_query_graphql_default = /*#__PURE__*/__webpack_require__.n(landing_page_query_graphql);
;// CONCATENATED MODULE: ./src/areas/landing-page/queries/use-landing-page-query.ts


function useLandingPageQuery(variables) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (landing_page_query_graphql_default()),
        routeName: "start",
        variables: variables
    });
}

// EXTERNAL MODULE: ./src/hooks/campaigns/use-campaigns.ts
var use_campaigns = __webpack_require__(56525);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/arrow-right/index.js
var arrow_right = __webpack_require__(7743);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
;// CONCATENATED MODULE: ./src/areas/landing-page/components/campaigns-banner/banner/styles.ts
function banner_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function banner_styles_templateObject() {
    var data = banner_styles_taggedTemplateLiteral([
        "\n    width: 100%;\n  "
    ]);
    banner_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function banner_styles_templateObject1() {
    var data = banner_styles_taggedTemplateLiteral([
        "\n  width: ",
        ";\n  background-color: ",
        ";\n  background-image: ",
        ";\n  background-size: cover;\n  background-position: center;\n  border-radius: 24px;\n  display: flex;\n  align-items: end;\n  justify-content: flex-start;\n  text-align: left;\n  flex-grow: 1;\n  ",
        "\n"
    ]);
    banner_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function banner_styles_templateObject2() {
    var data = banner_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n"
    ]);
    banner_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function banner_styles_templateObject3() {
    var data = banner_styles_taggedTemplateLiteral([
        "\n     padding: ",
        ";\n  "
    ]);
    banner_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function banner_styles_templateObject4() {
    var data = banner_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  justify-content: flex-end;\n  padding: ",
        ";\n  height: 100%;\n  ",
        "\n"
    ]);
    banner_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function banner_styles_templateObject5() {
    var data = banner_styles_taggedTemplateLiteral([
        "\n  width: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: normal;\n  margin-bottom: 16px;\n"
    ]);
    banner_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function banner_styles_templateObject6() {
    var data = banner_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-start;\n  width: 100%;\n"
    ]);
    banner_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function banner_styles_templateObject7() {
    var data = banner_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n\n  &:hover {\n    & > * {\n      color: ",
        ";\n      opacity: 0.72;\n    }\n  }\n"
    ]);
    banner_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var BannerContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BannerContainer",
    componentId: "sc-0-0"
})(banner_styles_templateObject1(), function(param) {
    var bannerWidth = param.bannerWidth;
    return bannerWidth;
}, function(param) {
    var themeType = param.themeType, imgUrl = param.imgUrl;
    if (imgUrl) {
        return "transparent";
    }
    return themeType === "dark" ? design_tokens.lightThemeColors.maybeBlue900 : design_tokens.lightThemeColors.maybeBlue100;
}, function(param) {
    var imgUrl = param.imgUrl;
    return imgUrl ? "url(".concat(imgUrl, ")") : "none";
}, base/* media.smallDown */.BC.smallDown(banner_styles_templateObject()));
var ClickableBanner = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "ClickableBanner",
    componentId: "sc-0-1"
})(banner_styles_templateObject2());
var BannerContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BannerContent",
    componentId: "sc-0-2"
})(banner_styles_templateObject4(), function(param) {
    var bannerSize = param.bannerSize;
    return bannerSize === "small" ? "24px" : "40px";
}, base/* media.smallDown */.BC.smallDown(banner_styles_templateObject3(), function(param) {
    var bannerSize = param.bannerSize;
    return bannerSize === "small" ? "24px" : "40px 24px";
}));
var TextContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TextContainer",
    componentId: "sc-0-3"
})(banner_styles_templateObject5(), function(param) {
    var bannerSize = param.bannerSize;
    return bannerSize === "small" ? "70%" : "60%";
});
var ButtonContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ButtonContainer",
    componentId: "sc-0-4"
})(banner_styles_templateObject6());
var ReadMoreContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ReadMoreContainer",
    componentId: "sc-0-5"
})(banner_styles_templateObject7(), function(param) {
    var theme = param.theme, themeType = param.themeType;
    return themeType === "dark" ? theme.colors.base100 : theme.colors.base900;
});

;// CONCATENATED MODULE: ./src/areas/landing-page/components/campaigns-banner/banner/index.tsx








function scaleImageUrl(url, bannerSize, isMobile) {
    var dimensions = {
        small: {
            width: isMobile ? 375 : 300
        },
        medium: {
            width: isMobile ? 375 : 400
        },
        large: {
            width: isMobile ? 375 : 600
        },
        mega: {
            width: isMobile ? 375 : 600
        }
    };
    var width = dimensions[bannerSize].width;
    var separator = url.includes("?") ? "&" : "?";
    return "".concat(url).concat(separator, "w=").concat(width, "&fit=max&dpr=2&auto=format&q=75");
}
var Banner = function(param) {
    var data = param.data;
    var ref, ref1;
    var bannerSize = data.bannerSize, overline = data.overline, title = data.title, copy = data.copy, theme = data.theme, backgroundImageUrl = data.backgroundImageUrl, button = data.button;
    var market = (0,react.useContext)(app_context/* AppContext */.Il).market;
    var isMobile = (0,react.useContext)(viewport/* ViewportContext */.R).isMobile;
    var bannerSizeMapped = bannerSize;
    var scaledDownImageUrl = backgroundImageUrl ? scaleImageUrl(backgroundImageUrl, bannerSizeMapped, isMobile !== null && isMobile !== void 0 ? isMobile : false) : backgroundImageUrl;
    var themeType = theme === "dark" || theme === "light" ? theme : "light";
    var _domain;
    var isExternalUrl = !(button === null || button === void 0 ? void 0 : (ref = button.url) === null || ref === void 0 ? void 0 : ref.startsWith((_domain = market.domain) !== null && _domain !== void 0 ? _domain : ""));
    var _domain1;
    var url = isExternalUrl ? button === null || button === void 0 ? void 0 : button.url : button === null || button === void 0 ? void 0 : (ref1 = button.url) === null || ref1 === void 0 ? void 0 : ref1.split((_domain1 = market.domain) !== null && _domain1 !== void 0 ? _domain1 : "")[1];
    var SmallBannerConfig = {
        titleScale: "1.375rem",
        titleScaleMobile: "1.375rem",
        titleLineHeight: "1.2",
        titleMarginBottom: "0.5rem",
        bannerWidth: "calc(33% - 24px)"
    };
    var MediumBannerConfig = {
        titleScale: "2.5rem",
        titleScaleMobile: "2rem",
        titleLineHeight: "1.1",
        titleMarginBottom: "1rem",
        bannerWidth: "calc(50% - 24px)"
    };
    var LargeBannerConfig = {
        titleScale: "2.5rem",
        titleScaleMobile: "2rem",
        titleLineHeight: "1.1",
        titleMarginBottom: "1rem",
        bannerWidth: "calc(66% - 24px)"
    };
    var MegaBannerConfig = {
        titleScale: "4rem",
        titleScaleMobile: "2.5rem",
        titleLineHeight: "1.1",
        titleMarginBottom: "1rem",
        bannerWidth: "100%"
    };
    var bannerConfig = {
        small: SmallBannerConfig,
        medium: MediumBannerConfig,
        large: LargeBannerConfig,
        mega: MegaBannerConfig
    };
    var handleOnClick = (0,react.useCallback)(function(event) {
        var href = event.currentTarget.getAttribute("href");
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.BANNER */.U.BANNER,
            nextPage: href
        });
    }, []);
    return /*#__PURE__*/ react.createElement(BannerContainer, {
        bannerWidth: bannerConfig[bannerSizeMapped].bannerWidth,
        themeType: themeType,
        imgUrl: scaledDownImageUrl
    }, /*#__PURE__*/ react.createElement(ClickableBanner, {
        onClick: handleOnClick,
        to: url,
        isExternal: isExternalUrl
    }, /*#__PURE__*/ react.createElement(BannerContent, {
        bannerSize: bannerSizeMapped
    }, /*#__PURE__*/ react.createElement(TextContainer, {
        bannerSize: bannerSizeMapped
    }, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, {
        color: theme === "dark" ? text_variants.FontColor.LIGHT : text_variants.FontColor.PRIMARY,
        emphasis: theme === "dark" ? text_variants.FontEmphasis.MEDIUM : text_variants.FontEmphasis.HIGH
    }, overline), /*#__PURE__*/ react.createElement(text_variants.H2Text, {
        style: {
            fontSize: isMobile ? bannerConfig[bannerSizeMapped].titleScaleMobile : bannerConfig[bannerSizeMapped].titleScale,
            lineHeight: bannerConfig[bannerSizeMapped].titleLineHeight,
            marginBottom: bannerConfig[bannerSizeMapped].titleMarginBottom
        },
        color: theme === "dark" ? text_variants.FontColor.LIGHT : text_variants.FontColor.DARK,
        emphasis: text_variants.FontEmphasis.HIGH
    }, title), /*#__PURE__*/ react.createElement(text_variants.BodyMediumText, {
        color: theme === "dark" ? text_variants.FontColor.LIGHT : text_variants.FontColor.DARK,
        emphasis: text_variants.FontEmphasis.HIGH,
        scale: bannerSizeMapped === "small" ? text_variants.FontScale.S : text_variants.FontScale.M
    }, copy)), /*#__PURE__*/ react.createElement(ButtonContainer, null, bannerSizeMapped !== "small" ? /*#__PURE__*/ react.createElement(button_variants.PrimaryButton, {
        style: {
            padding: "10px 24px"
        }
    }, button === null || button === void 0 ? void 0 : button.text) : /*#__PURE__*/ react.createElement(ReadMoreContainer, {
        themeType: themeType
    }, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, {
        color: theme === "dark" ? text_variants.FontColor.LIGHT : text_variants.FontColor.DARK,
        emphasis: text_variants.FontEmphasis.HIGH,
        scale: bannerSizeMapped === "small" ? text_variants.FontScale.S : text_variants.FontScale.M
    }, button === null || button === void 0 ? void 0 : button.text), /*#__PURE__*/ react.createElement(arrow_right/* IconArrowRight */.E, {
        color: theme === "dark" ? "base100" : "base900",
        size: 20,
        style: {
            marginLeft: "8px"
        }
    }))))));
};

;// CONCATENATED MODULE: ./src/areas/landing-page/components/campaigns-banner/index.tsx
function campaigns_banner_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function campaigns_banner_templateObject() {
    var data = campaigns_banner_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px;\n  max-width: 980px;\n"
    ]);
    campaigns_banner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledBannerContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledBannerContainer",
    componentId: "sc-0-0"
})(campaigns_banner_templateObject());
var CampaignsBannerArea = function(param) {
    var data = param.data;
    if (!data || data.length === 0) return null;
    return /*#__PURE__*/ react.createElement(StyledBannerContainer, null, data.map(function(banner) {
        return /*#__PURE__*/ react.createElement(Banner, {
            key: banner._key,
            data: banner
        });
    }));
};
/* harmony default export */ var campaigns_banner = (CampaignsBannerArea);

;// CONCATENATED MODULE: ./src/areas/landing-page/landing-page.tsx
function landing_page_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function landing_page_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return landing_page_arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function landing_page_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function landing_page_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function landing_page_toConsumableArray(arr) {
    return landing_page_arrayWithoutHoles(arr) || landing_page_iterableToArray(arr) || landing_page_unsupportedIterableToArray(arr) || landing_page_nonIterableSpread();
}
function landing_page_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return landing_page_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return landing_page_arrayLikeToArray(o, minLen);
}


























var selectActiveCampaign = function(state) {
    return state.globals.campaigns && state.globals.campaigns.active.find(function(c) {
        return c.type === "OFFER" || c.type === "SEARCH_BANNER";
    });
};
var selectBigCampaignBanner = function(state) {
    return state.globals.campaignBanners && state.globals.campaignBanners.active.find(function(banner) {
        return banner.type === "LANDING_PAGE_BIG";
    });
};
var selectCampaignBanners = function(state) {
    return state.globals.campaignBanners;
};
// List items for the category list
var getListItems = function(appContext, activeCampaign, rootCategories) {
    var _listItems;
    var t = appContext.t, linkTo = appContext.linkTo, market = appContext.market;
    var listItems = [];
    // Campaign link
    var activeCampaignLogo = activeCampaign && activeCampaign.banners && activeCampaign.banners.find(function(banner) {
        return banner && banner.type.toUpperCase() === "BANNER_LOGO_BIG";
    });
    if (activeCampaign) {
        listItems.push({
            id: "activeCampaign",
            name: activeCampaign.name,
            pathName: activeCampaign.web_uri && activeCampaign.web_uri.responsive,
            logo: {
                192: activeCampaignLogo ? activeCampaignLogo.imageUrl : null
            }
        });
    }
    // Promotions link
    if (market.promotions.enabled) {
        listItems.push({
            id: "promotions",
            logo: "".concat(market.cdn, "/g/rfe/icons/promotions_icon.png"),
            name: t("search", "scoped-search.promotion-title"),
            pathName: linkTo("promotions")
        });
    }
    // Used products link
    listItems.push({
        id: "used",
        logo: "".concat(market.cdn, "/g/rfe/icons/used_products.png"),
        name: t("product", "product.used-products"),
        pathName: linkTo("used")
    });
    // Categories
    var categories = (rootCategories || []).map(function(category) {
        return category ? _objectSpreadProps(_objectSpread({}, category), {
            logo: {
                192: category.logo
            }
        }) : null;
    }).filter(function(x) {
        return x;
    });
    (_listItems = listItems).push.apply(_listItems, landing_page_toConsumableArray(categories));
    return listItems;
};
var LandingPage = function(param) {
    var data = param.data;
    var appContext = (0,app_context/* useAppContext */.bp)();
    var linkTo = appContext.linkTo;
    var isTablet = (0,context/* useViewportContext */.Ak)().isTablet;
    var startPageBanners = (0,use_campaigns/* useCampaigns */.t)().startPageBanners;
    var activeCampaign = (0,es/* useSelector */.v9)(selectActiveCampaign);
    var bigCampaignBanner = (0,es/* useSelector */.v9)(selectBigCampaignBanner);
    var campaignBanners = (0,es/* useSelector */.v9)(selectCampaignBanners);
    var campaignDeals = data.campaignDeals, featuredProductsArray = data.featuredProductsArray, rootCategories = data.rootCategories, popularFacets = data.popularFacets, landingPageArticles = data.landingPageArticles;
    var categoriesLimit = isTablet ? 9 : 8;
    var listItems = rootCategories ? getListItems(appContext, activeCampaign, rootCategories) : [];
    var beforeBanners = campaignBanners && campaignBanners.active.filter(function(b) {
        return b && b.type === "BEFORE_PROMO_BANNER";
    });
    return /*#__PURE__*/ react.createElement(Root, null, /*#__PURE__*/ react.createElement(SearchHero, null), /*#__PURE__*/ react.createElement(Content, null, /*#__PURE__*/ react.createElement(variants.Column, {
        gap: 1.5
    }, /*#__PURE__*/ react.createElement(panel/* Panel */.s_, {
        containerProps: {
            "data-test": "Panel",
            "data-test-type": "categories"
        }
    }, /*#__PURE__*/ react.createElement(CategoryList, {
        categories: listItems,
        displayLinkedCategories: false,
        displayMobileSubLinks: false,
        limitCategories: categoriesLimit
    })), bigCampaignBanner && /*#__PURE__*/ react.createElement(campaign_banner/* default */.Z, _extends({
        activeId: activeCampaign.id,
        url: bigCampaignBanner.url,
        imageUrl: bigCampaignBanner.imageUrl
    }, bigCampaignBanner.options)), /*#__PURE__*/ react.createElement(campaigns_banner, {
        data: startPageBanners.top
    }), /*#__PURE__*/ react.createElement(dist_module/* AdPlacement */.ZD, {
        format: "toppanorama_wde"
    }), beforeBanners && beforeBanners.length > 0 && /*#__PURE__*/ react.createElement(promo_banner/* default */.Z, {
        inverted: true,
        banners: beforeBanners
    }), /*#__PURE__*/ react.createElement(campaign_deals/* default */.Z, {
        deals: campaignDeals,
        negativeMargin: true,
        onlyFeatured: true
    }), /*#__PURE__*/ react.createElement(campaigns_banner, {
        data: startPageBanners.middle
    }), /*#__PURE__*/ react.createElement(recently_visited/* default */.Z, null), /*#__PURE__*/ react.createElement(AdPlacementMarginY, null, /*#__PURE__*/ react.createElement(dist_module/* AdPlacement */.ZD, {
        format: "toppanorama"
    })), featuredProductsArray.map(function(featuredProducts) {
        return /*#__PURE__*/ react.createElement(featured_products, {
            key: featuredProducts.title,
            featuredProducts: featuredProducts,
            negativeMargin: true
        });
    }), /*#__PURE__*/ react.createElement(campaigns_banner, {
        data: startPageBanners.bottom
    }), /*#__PURE__*/ react.createElement(popular_products, {
        negativeMargin: true
    }), appContext.market.experts.enabled && data.expertLandingPage && /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(experts, {
        data: data.expertLandingPage
    })), landingPageArticles && /*#__PURE__*/ react.createElement(LandingPageFeaturedArticles, {
        articles: landingPageArticles.map(function(article) {
            return _objectSpreadProps(_objectSpread({}, article), {
                pathName: linkTo("article", {
                    slug: article.slug
                }),
                imageUrl: article.thumbnail
            });
        }),
        showAd: true
    }), /*#__PURE__*/ react.createElement(NewProducts, null), /*#__PURE__*/ react.createElement(trending_products, {
        negativeMargin: true
    }), /*#__PURE__*/ react.createElement(AdPlacementMarginTop, null, /*#__PURE__*/ react.createElement(dist_module/* AdPlacement */.ZD, {
        format: "panorama_1_wde",
        triggerPoint: 0
    }), /*#__PURE__*/ react.createElement(dist_module/* AdPlacement */.ZD, {
        format: "panorama_2",
        triggerPoint: 0
    })), popularFacets && /*#__PURE__*/ react.createElement(popular_facets/* default */.Z, {
        popularFacets: popularFacets
    }))));
};
var LandingPageLoader = function() {
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var landingPageQuery = useLandingPageQuery(_objectSpread({}, route === null || route === void 0 ? void 0 : route.variables));
    var data = landingPageQuery.data;
    var adsConfig = {
        pageOptions: {
            pageType: "index"
        },
        formats: [
            "panorama_1",
            "panorama_2",
            "panorama_1_wde",
            "toppanorama_wde",
            "toppanorama",
            "welcome_page_wde",
            "welcome_page"
        ]
    };
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true,
        noTopAds: true,
        adsConfig: adsConfig
    }, landingPageQuery.isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, data != null ? /*#__PURE__*/ react.createElement(LandingPage, {
        data: data
    }) : null);
};
/* harmony default export */ var landing_page = (LandingPageLoader);


/***/ }),

/***/ 39438:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B9": () => (/* binding */ FEEDBACK_PROMPT_ROW_POSITION),
/* harmony export */   "DT": () => (/* binding */ MIXED_CONTENT_ROW_POSITIONS),
/* harmony export */   "cj": () => (/* binding */ MIXED_CONTENT_VISIBILITY_MIN_PRODUCTS_COUNT)
/* harmony export */ });
var FEEDBACK_PROMPT_ROW_POSITION = 6;
var MIXED_CONTENT_ROW_POSITIONS = [
    // This is the row position of the first mixed content card and the second mixed content card,
    // per breakpoint.
    {
        desktop: 2,
        tablet: 3,
        mobile: 5
    },
    {
        desktop: 5,
        tablet: 7,
        mobile: 13
    },
    {
        desktop: 8,
        tablet: 12,
        mobile: 20
    },
    {
        desktop: 11,
        tablet: 15,
        mobile: 25
    }
];
var MIXED_CONTENT_VISIBILITY_MIN_PRODUCTS_COUNT = [
    // This is the minimum number of products that need to be visible
    // for the first mixed content card and the second mixed content card,
    // per breakpoint.
    {
        isDesktop: 6,
        isTablet: 7,
        isMobile: 6
    },
    {
        isDesktop: 16,
        isTablet: 14,
        isMobile: 14
    },
    {
        isDesktop: 26,
        isTablet: 27,
        isMobile: 26
    },
    {
        isDesktop: 35,
        isTablet: 34,
        isMobile: 34
    }
];


/***/ }),

/***/ 74596:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bq": () => (/* binding */ getVisibleCards),
/* harmony export */   "F6": () => (/* binding */ getRowPosition),
/* harmony export */   "ME": () => (/* binding */ getLinkByType)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39438);
/* harmony import */ var src_areas_expert_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54712);


var getLinkByType = function(item, linkTo) {
    switch(item.__typename){
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_1__/* .ContentTypes.TOPLIST */ .b.TOPLIST:
            return item.headlineInfo.url;
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_1__/* .ContentTypes.GUIDE */ .b.GUIDE:
            return item.url;
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_1__/* .ContentTypes.ARTICLE */ .b.ARTICLE:
            return item.link;
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_1__/* .ContentTypes.SPONSORED_ARTICLE */ .b.SPONSORED_ARTICLE:
            return linkTo("sponsoredArticle", {
                slug: item.slug
            });
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_1__/* .ContentTypes.GENERIC_ARTICLE */ .b.GENERIC_ARTICLE:
            return linkTo("article", {
                slug: item.slug
            });
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_1__/* .ContentTypes.EDITORIAL_LANDING_PAGE */ .b.EDITORIAL_LANDING_PAGE:
            return linkTo("editorialLandingPage", {
                slug: item.slug
            });
        default:
            return undefined;
    }
};
// Gets the amount of mixed content cards that can be shown based on the number of products in the grid.
var getVisibleCards = function(items, productsCount, currentViewport) {
    try {
        return items.filter(function(_, index) {
            return _constants__WEBPACK_IMPORTED_MODULE_0__/* .MIXED_CONTENT_VISIBILITY_MIN_PRODUCTS_COUNT */ .cj[index][currentViewport] <= productsCount;
        });
    } catch (e) {
        throw e;
    }
};
var getRowPosition = function(index) {
    return _constants__WEBPACK_IMPORTED_MODULE_0__/* .MIXED_CONTENT_ROW_POSITIONS */ .DT[index];
};


/***/ }),

/***/ 98864:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": () => (/* binding */ trackCategoryPageExpertCarouselInfoList),
/* harmony export */   "t": () => (/* binding */ trackCategoryPageExpertCarouselCard)
/* harmony export */ });
/* harmony import */ var _client_data_layer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24005);

var trackCategoryPageExpertCarouselCard = function(pageUrl, cardType) {
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("productCollectionExpertCarouselCardClick", {
        pageUrl: pageUrl,
        cardType: cardType
    });
};
var trackCategoryPageExpertCarouselInfoList = function(pageUrl, cardType) {
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("productCollectionExpertCarouselInfoClick", {
        pageUrl: pageUrl,
        cardType: cardType
    });
};


/***/ }),

/***/ 97963:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": () => (/* binding */ CategoryList)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/arrow-right/index.js
var arrow_right = __webpack_require__(7743);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(24005);
;// CONCATENATED MODULE: ./src/components/category-list/utils.ts

var atLeast = function(count) {
    return function(item) {
        return item && Array.isArray(item) && item.length >= count;
    };
};
var atLeastOne = atLeast(1);
var haveChildren = function(item) {
    return atLeastOne(item.children);
};
var MAIN_LINK = "main";
var SUBCATEGORY_LINK = "subcategory";
var SHOW_ALL_LINK = "showAll";
var trackClick = function(category, linkKind) {
    (0,data_layer/* pushEvent */.A)("categoryListClick", {
        category: category,
        linkKind: linkKind,
        isSubcategory: linkKind === SUBCATEGORY_LINK,
        insideHoverMenu: linkKind !== MAIN_LINK
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/category-list/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    width: 56px;\n    height: 56px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  width: 40px;\n  height: 40px;\n  ",
        "\n\n  /* stylelint-disable */\n  image-rendering: -webkit-optimize-contrast;\n  transform: translateZ(0);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-column-gap: ",
        ";\n    grid-row-gap: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      grid-template-columns: repeat(4, 1fr);\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    justify-content: ",
        ";\n    padding: 0;\n    list-style: none;\n    margin-bottom: 0;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.5;\n  letter-spacing: 0;\n  :hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  display: flex;\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        '\n              /* Remove the bottom border as the list of sub-categories constitutes the "bottom" of the box */\n              border-bottom: 1px solid ',
        ";\n              border-bottom-left-radius: 0;\n              border-bottom-right-radius: 0;\n              transition: ",
        ";\n            "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom: none;\n      padding: 0;\n\n      &:hover {\n        ",
        " {\n          ",
        "    \n        }\n\n        > ",
        " {\n          opacity: 1;\n          visibility: visible;\n          background: ",
        ";\n          width: 100%;\n          box-shadow: 0 5px 10px -3px rgba(0, 0, 0, 0.1);\n          border: 1px solid ",
        ";\n          border-top: none;\n          border-radius: 0 0 8px 8px;\n          z-index: 1;\n          transition: ",
        ";\n        }\n      }\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    list-style: none;\n    padding: ",
        ";\n    border-bottom: 1px solid ",
        ";\n    /* Hides the items with display:none instead of not rendering them due to SEO reasons */\n    display: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    order: 99;\n    display: none;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  order: 4;\n  flex-basis: 100%;\n  margin: 0;\n  list-style: none;\n\n  ",
        ";\n\n  > *:not(:empty) {\n    margin: 5px 0;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  list-style: none;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  list-style: none;\n  + ",
        " {\n    margin-top: 10px;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n    border-radius: 8px;\n    padding: ",
        " ",
        "\n    ",
        " ",
        ";\n    border: ",
        ";\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    height: 100%;\n    margin: 0;\n    padding: ",
        " ",
        "\n      ",
        " ",
        ";\n\n    :hover {\n      color: ",
        ";\n    }\n\n    ",
        "\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  padding: 2px 0;\n  color: ",
        ";\n\n  &:hover {\n    text-decoration-line: underline;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n    display: block;\n    position: absolute;\n    background: ",
        ";\n    top: 100%;\n    z-index: 1;\n    visibility: hidden;\n    opacity: 0;\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0;\n  display: none;\n  padding: ",
        ";\n  padding-top: 0;\n\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n    margin: ",
        ";\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "grid-column: span 3"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "grid-column: span 4"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n\n  ",
        "\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}




var HOVER_DELAY = 150;
var CategoryImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "CategoryImage",
    componentId: "sc-0-0"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.largeOnly */.BC.largeOnly(_templateObject()));
var StyledCategoryList = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "StyledCategoryList",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), props.$few ? "flex-start" : "space-between", base/* media.mediumUp */.BC.mediumUp(_templateObject2(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing075 */.bK.measurements.spacing075), base/* media.largeUp */.BC.largeUp(_templateObject3()));
});
var TopLevelName = styled_components_browser_esm["default"].span.withConfig({
    displayName: "TopLevelName",
    componentId: "sc-0-2"
})(_templateObject5(), text_variants.FontWeight.HEAVIER, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var TopLevelIcon = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TopLevelIcon",
    componentId: "sc-0-3"
})(_templateObject7(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* media.mediumUp */.BC.mediumUp(_templateObject6()));
var TopLevelItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "TopLevelItem",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject10(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, props.theme.colors.base200, props.$hidden ? "none" : "block", base/* media.mediumUp */.BC.mediumUp(_templateObject9(), TopLevelLink, props.$hasChildren && (0,styled_components_browser_esm.css)(_templateObject8(), props.theme.colors.base0, "border 200ms ease ".concat(HOVER_DELAY, "ms, border-radius 200ms ease ").concat(HOVER_DELAY, "ms")), SubLevelList, props.theme.bg.primary, props.theme.colors.base200, "opacity 200ms ease ".concat(HOVER_DELAY, "ms")));
});
var AdItem = (0,styled_components_browser_esm["default"])(TopLevelItem).withConfig({
    displayName: "AdItem",
    componentId: "sc-0-5"
})(_templateObject12(), base/* media.mediumUp */.BC.mediumUp(_templateObject11()));
var SubLevelItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "SubLevelItem",
    componentId: "sc-0-6"
})(_templateObject13());
var SubLevelItemShowAll = styled_components_browser_esm["default"].li.withConfig({
    displayName: "SubLevelItemShowAll",
    componentId: "sc-0-7"
})(_templateObject14(), SubLevelItem);
var TopLevelLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "TopLevelLink",
    componentId: "sc-0-8"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject16(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
        return p.theme.text.linkInternalHover;
    }, base/* media.mediumUp */.BC.mediumUp(_templateObject15(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, "1px solid ".concat(props.theme.colors.base200)));
});
var SubLevelLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "SubLevelLink",
    componentId: "sc-0-9"
})(_templateObject17(), function(p) {
    return p.theme.text.linkInternal;
});
var SubLevelList = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "SubLevelList",
    componentId: "sc-0-10"
})(_templateObject19(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.mediumUp */.BC.mediumUp(_templateObject18(), function(p) {
    return p.theme.bg.primary;
}));
var ShowMoreButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShowMoreButtonWrapper",
    componentId: "sc-0-11"
})(_templateObject23(), base/* media.smallOnly */.BC.smallOnly(_templateObject20(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100), base/* media.mediumOnly */.BC.mediumOnly(_templateObject21()), base/* media.largeUp */.BC.largeUp(_templateObject22()));

;// CONCATENATED MODULE: ./src/components/category-list/components/category-item-show-all.tsx




var CategoryItemShowAll = function(props) {
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var topLevel = props.item;
    return /*#__PURE__*/ react.createElement(SubLevelItemShowAll, {
        key: "show-all"
    }, topLevel.externalUri && /*#__PURE__*/ react.createElement(SubLevelLink, {
        as: "a",
        href: topLevel.externalUri
    }, t("category", "subcategories.show-all")), !topLevel.externalUri && /*#__PURE__*/ react.createElement(SubLevelLink, {
        to: props.linkToItem(topLevel),
        onClick: function() {
            return trackClick(topLevel, SHOW_ALL_LINK);
        }
    }, t("category", "subcategories.show-all")));
};
/* harmony default export */ var category_item_show_all = (CategoryItemShowAll);

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/components/category-list/components/category-item-children.tsx





var CategoryItemChildren = function(props) {
    var topLevel = props.item;
    var subCategoryMap = props.subCategoryMap, linkToItem = props.linkToItem;
    return haveChildren(topLevel) ? /*#__PURE__*/ react.createElement(SubLevelList, null, subCategoryMap[topLevel.id].map(function(subLevel) {
        return /*#__PURE__*/ react.createElement(SubLevelItem, {
            key: subLevel.id
        }, subLevel.externalUri && /*#__PURE__*/ react.createElement(SubLevelLink, {
            as: "a",
            href: subLevel.externalUri
        }, subLevel.name), !subLevel.externalUri && /*#__PURE__*/ react.createElement(SubLevelLink, {
            to: linkToItem(subLevel),
            onClick: function() {
                trackClick(subLevel, SUBCATEGORY_LINK);
                (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.CATEGORY_LIST_SUB_LVL */.U.CATEGORY_LIST_SUB_LVL,
                    nextPage: linkToItem(subLevel)
                });
            }
        }, subLevel.name));
    }), /*#__PURE__*/ react.createElement(category_item_show_all, {
        item: topLevel,
        linkToItem: linkToItem
    })) : null;
};
/* harmony default export */ var category_item_children = (CategoryItemChildren);

// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
;// CONCATENATED MODULE: ./src/components/category-list/components/sub-links/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: ",
        " 0 ",
        "\n    0;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Root = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Root",
    componentId: "sc-0-0"
})(styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing150 */.bK.measurements.spacing150);

;// CONCATENATED MODULE: ./src/components/category-list/components/sub-links/category-item-sub-links.tsx






var CategoryItemSubLinks = function(props) {
    var topLevel = props.item;
    var subCategoryMap = props.subCategoryMap, linkToItem = props.linkToItem;
    return haveChildren(topLevel) ? /*#__PURE__*/ react.createElement(Root, null, subCategoryMap[topLevel.id].map(function(subLevel) {
        if (!subLevel.externalUri) {
            return /*#__PURE__*/ react.createElement(variants.TonalButton, {
                key: subLevel.id,
                container: clickable/* Clickable */.P,
                containerProps: {
                    to: linkToItem(subLevel)
                },
                onClick: function() {
                    trackClick(subLevel, SUBCATEGORY_LINK);
                    (0,tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking/* InternalNavigationScope.CATEGORY_LIST_SUB_LVL */.U.CATEGORY_LIST_SUB_LVL,
                        nextPage: linkToItem(subLevel)
                    });
                },
                size: variants.ButtonSize.SMALL
            }, subLevel.name);
        }
        return /*#__PURE__*/ react.createElement(variants.TonalButton, {
            key: subLevel.id,
            container: clickable/* Clickable */.P,
            containerProps: {
                to: subLevel.externalUri,
                isExternal: true
            },
            size: variants.ButtonSize.SMALL
        }, subLevel.name);
    })) : null;
};


;// CONCATENATED MODULE: ./src/components/category-list/components/category-item.tsx









var CategoryListItem = function(props) {
    var subCategoryMap = props.subCategoryMap, _displayMobileSubLinks = props.displayMobileSubLinks, displayMobileSubLinks = _displayMobileSubLinks === void 0 ? true : _displayMobileSubLinks, hidden = props.hidden;
    var topLevel = props.item;
    var linkTo = (0,app_context/* useAppContext */.bp)().linkTo;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    // Use pathName if set in order to handle campaign items
    var linkToItem = function(item) {
        return item.pathName || linkTo("category", item);
    };
    var logo = topLevel.logo;
    var logoUrl = typeof logo === "string" ? logo : logo && logo["192"];
    var topLevelIcon = displayMobileSubLinks ? /*#__PURE__*/ react.createElement(TopLevelIcon, null, /*#__PURE__*/ react.createElement(arrow_right/* IconArrowRight */.E, {
        size: 24
    })) : null;
    return /*#__PURE__*/ react.createElement(TopLevelItem, {
        $hasChildren: haveChildren(topLevel),
        $hidden: hidden,
        "data-test": "CategoryListItem",
        "data-test-level": "top"
    }, topLevel.externalUri && /*#__PURE__*/ react.createElement(TopLevelLink, {
        href: topLevel.externalUri,
        as: "a"
    }, topLevel.logo && /*#__PURE__*/ react.createElement(CategoryImage, {
        src: logoUrl,
        alt: "Category Logo"
    }), /*#__PURE__*/ react.createElement(TopLevelName, null, topLevel.name), topLevelIcon), !topLevel.externalUri && /*#__PURE__*/ react.createElement(TopLevelLink, {
        to: linkToItem(topLevel),
        onClick: function() {
            trackClick(topLevel, MAIN_LINK);
            (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.CATEGORY_LIST_TOP_LVL */.U.CATEGORY_LIST_TOP_LVL,
                nextPage: linkToItem(topLevel)
            });
        }
    }, topLevel.logo && /*#__PURE__*/ react.createElement(CategoryImage, {
        src: logoUrl,
        alt: "Category Logo"
    }), /*#__PURE__*/ react.createElement(TopLevelName, null, topLevel.name), topLevelIcon), /*#__PURE__*/ react.createElement(category_item_children, {
        item: topLevel,
        subCategoryMap: subCategoryMap,
        linkToItem: linkToItem
    }), isMobile && displayMobileSubLinks && /*#__PURE__*/ react.createElement(CategoryItemSubLinks, {
        item: topLevel,
        subCategoryMap: subCategoryMap,
        linkToItem: linkToItem
    }));
};
/* harmony default export */ var category_item = (CategoryListItem);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(2600);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
;// CONCATENATED MODULE: ./src/components/category-list/sub-category-map.ts
/* eslint-disable camelcase */ function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var getSubCategoryMap = function(categories, limitSubCategories, displayLinkedCategories) {
    var result = categories.reduce(function(map, param) {
        var id = param.id, children = param.children, path = param.semantic_id;
        if (displayLinkedCategories || typeof path !== "string" || !Array.isArray(children) || !children.length) {
            return _objectSpreadProps(_objectSpread({}, map), _defineProperty({}, id, Array.isArray(children) ? children.slice(0, limitSubCategories) : []));
        }
        // Filter out product collection duplicates
        var uniqueSubCategories = uniqBy_default()(children, function(param) {
            var subCategoryId = param.id, product_collection = param.product_collection;
            return product_collection || subCategoryId;
        });
        /**
       * HACK: Use semantic URL to filter out linked categories
       *
       * Semantic URL will contain a category's true path, so we can use it
       * here to determine if a category is linked (virtual) or in the correct
       * part of the tree.
       *
       * Example:
       * "Memory Cards" is listed under "Phones & GPS" > "Mobile Phone Accessories"
       * (/phones-gps/mobile-phone-accessories--c1307). But from the semantic URL
       * /computers-accessories/storage-media/memory-cards--c156 we can tell that it
       * actually belongs Under "Computers & Accessories" > "Storage Media".
       */ var pathWithoutId = path.replace(/--c\d+$/, "");
        var pathLength = pathWithoutId.length;
        return _objectSpreadProps(_objectSpread({}, map), _defineProperty({}, id, uniqueSubCategories.filter(function(param) {
            var subCategoryPath = param.semantic_id;
            return subCategoryPath.substring(0, pathLength) === pathWithoutId;
        }).slice(0, limitSubCategories)));
    }, {});
    // Special case - categories with only virtual children will become empty
    // In this case we will fall back to display children of linked categories
    if (!displayLinkedCategories) {
        Object.keys(result).forEach(function(key) {
            var subCategories = result[key];
            var category = categories.find(function(param) {
                var id = param.id;
                return id === key;
            });
            if (!subCategories.length && category && Array.isArray(category.children) && category.children.length) {
                // Create list with all other categories children
                var otherSubCategories = Object.keys(result).filter(function(k) {
                    return k !== key;
                }).flatMap(function(k) {
                    return result[k].map(function(param) {
                        var product_collection = param.product_collection, id = param.id;
                        return "".concat(product_collection, "|").concat(id);
                    });
                });
                var subCategoriesWithLinks = category.children.filter(function(param) {
                    var id = param.id, product_collection = param.product_collection;
                    return !otherSubCategories.includes("".concat(product_collection, "|").concat(id));
                });
                result[key] = subCategoriesWithLinks.length ? subCategoriesWithLinks.slice(0, limitSubCategories) : category.children.slice(0, limitSubCategories);
            }
        });
    }
    return result;
};

;// CONCATENATED MODULE: ./src/components/category-list/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








var CategoryList = function(props) {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    var _limitCategories = props.limitCategories, limitCategories = _limitCategories === void 0 ? isMobile ? 5 : undefined : _limitCategories, _limitSubCategories = props.limitSubCategories, limitSubCategories = _limitSubCategories === void 0 ? 5 : _limitSubCategories, _displayLinkedCategories = props.displayLinkedCategories, displayLinkedCategories = _displayLinkedCategories === void 0 ? true : _displayLinkedCategories, _displayMobileSubLinks = props.displayMobileSubLinks, displayMobileSubLinks = _displayMobileSubLinks === void 0 ? true : _displayMobileSubLinks, className = props.className;
    var ref = _slicedToArray((0,react.useState)(false), 2), showMoreCategories = ref[0], setShowMoreCategories = ref[1];
    var fewThreshold = 4;
    var categories = props.categories;
    var subCategoryMap = (0,react.useMemo)(function() {
        return getSubCategoryMap(categories, limitSubCategories, displayLinkedCategories);
    }, [
        categories,
        limitSubCategories,
        displayLinkedCategories
    ]);
    var shouldDisplayShowMoreButton = !!limitCategories && categories.length > limitCategories;
    var shouldLimitCategories = shouldDisplayShowMoreButton && !showMoreCategories;
    return atLeastOne(categories) ? /*#__PURE__*/ react.createElement(StyledCategoryList, {
        $few: categories.length < fewThreshold,
        "data-test": "CategoryList",
        className: className
    }, categories.map(function(topLevel, index) {
        return /*#__PURE__*/ react.createElement(category_item, {
            key: topLevel.id,
            item: topLevel,
            index: index,
            subCategoryMap: subCategoryMap,
            displayMobileSubLinks: displayMobileSubLinks,
            hidden: shouldLimitCategories && index >= limitCategories
        });
    }), shouldDisplayShowMoreButton && /*#__PURE__*/ react.createElement(ShowMoreButtonWrapper, null, /*#__PURE__*/ react.createElement(variants.TonalButton, {
        fullWidth: isMobile,
        onClick: function() {
            return setShowMoreCategories(!showMoreCategories);
        }
    }, showMoreCategories ? t("category", "category-limit.show-less") : t("category", "category-limit.show-more")))) : null;
};



/***/ }),

/***/ 91441:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": () => (/* binding */ ListItem)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40889);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



var ListItem = function(param) {
    var children = param.children, name = param.name, link = param.link, image = param.image, callToActionText = param.callToActionText, showArrow = param.showArrow, showBackArrow = param.showBackArrow, _onClick = param.onClick, onClick = _onClick === void 0 ? src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT : _onClick, className = param.className, isExternal = param.isExternal, linkAttributes = param.linkAttributes, dataTest = param["data-test"], disabled = param.disabled;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .ListItem */ .HC, _extends({
        onClick: onClick,
        className: className,
        to: link,
        isExternal: isExternal
    }, linkAttributes || {}, {
        "data-test": dataTest,
        disabled: disabled
    }), showBackArrow && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .LeftArrow */ .IT, null), image && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, null, image), children, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Name */ .VG, null, name), callToActionText && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .CallToAction */ .Jd, null, callToActionText), showArrow && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RightArrow */ .UV, null));
};


/***/ }),

/***/ 40889:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": () => (/* binding */ Image),
/* harmony export */   "HC": () => (/* binding */ ListItem),
/* harmony export */   "IT": () => (/* binding */ LeftArrow),
/* harmony export */   "Jd": () => (/* binding */ CallToAction),
/* harmony export */   "UV": () => (/* binding */ RightArrow),
/* harmony export */   "VG": () => (/* binding */ Name)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var _prisjakt_ui_icon_chevron_left__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37456);
/* harmony import */ var _prisjakt_ui_icon_chevron_right__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93345);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89218);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21541);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      cursor: default;\n      opacity: 0.5;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  cursor: pointer;\n  min-height: 48px;\n  padding: ",
        " ",
        ";\n  text-align: left;\n  display: flex;\n  align-items: center;\n\n  /* Set the width and box-sizing to account for inconsistencies between <button> and <a> */\n  box-sizing: border-box;\n  width: 100%;\n\n  &:hover,\n  &.focus-visible {\n    background-color: ",
        ";\n    outline: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  flex: 0 1 50%;\n  margin-left: ",
        ";\n  overflow: hidden;\n  text-align: right;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  margin-left: ",
        ";\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  margin-right: ",
        ";\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var padding = src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050;
var ListItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_clickable__WEBPACK_IMPORTED_MODULE_3__/* .Clickable */ .P).withConfig({
    displayName: "ListItem",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.theme.text.primary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025, padding, function(props) {
    return props.theme.bg.secondary;
}, function(props) {
    return props.disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject());
});
var Image = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Image",
    componentId: "sc-0-1"
})(_templateObject2(), padding);
var Name = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__.TitleSmallText).withConfig({
    displayName: "Name",
    componentId: "sc-0-2"
})(_templateObject3());
var CallToAction = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "CallToAction",
    componentId: "sc-0-3"
})(_templateObject4(), function(props) {
    return props.theme.text.callToAction;
}, padding);
var RightArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_right__WEBPACK_IMPORTED_MODULE_2__.IconChevronRight).attrs({
    size: 20
}).withConfig({
    displayName: "RightArrow",
    componentId: "sc-0-4"
})(_templateObject5(), padding);
var LeftArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_left__WEBPACK_IMPORTED_MODULE_1__.IconChevronLeft).attrs({
    size: 20
}).withConfig({
    displayName: "LeftArrow",
    componentId: "sc-0-5"
})(_templateObject6(), padding);


/***/ }),

/***/ 66050:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": () => (/* binding */ useEffectOnMount)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

/**
 * Hook to use when you want to execute only on mounting.
 * This will avoid eslint warnings when using an empty dependency array, and clearly states your intentions.
 */ var useEffectOnMount = function(effect) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(effect, []);
};


/***/ }),

/***/ 23920:
/***/ ((module) => {

module.exports = "query newProducts {\n  ...newProductsFragment\n}\n\nfragment newProductsFragment on RootQuery {\n  newProductRecommendations: recommendation {\n    newReleases(limit: 20, onlyFromFeaturedStores: false) {\n      nodes {\n        id\n        name\n        pathName\n        media {\n          first(width: _140)\n        }\n        priceSummary {\n          regular\n        }\n        alert {\n          id\n        }\n        category {\n          id\n          name\n        }\n        isExpertTopRated\n      }\n    }\n  }\n}"

/***/ }),

/***/ 6281:
/***/ ((module) => {

module.exports = "query popularProducts {\n  category(id: \"v100\") {\n    products(limit: 5, sort: \"popularity\", onlyFromFeaturedStores: true) {\n      nodes {\n        id\n        name\n        media {\n          first(width: _140)\n        }\n        userReviewSummary {\n          rating\n          count\n        }\n        aggregatedRating {\n          score\n          count\n        }\n        priceSummary {\n          regular\n          alternative\n          inStock\n        }\n        category {\n          id\n          name\n        }\n        brand {\n          featured\n          logo\n          name\n        }\n        isExpertTopRated\n      }\n    }\n  }\n}"

/***/ }),

/***/ 13707:
/***/ ((module) => {

module.exports = "query trendingProducts {\n  ...trendingProductsFragment\n}\n\nfragment trendingProductsFragment on RootQuery {\n  trendingProducts: recommendation {\n    trendingProducts(limit: 20, onlyFromFeaturedStores: true) {\n      nodes {\n        id\n        name\n        media {\n          first(width: _140)\n        }\n        priceSummary {\n          regular\n        }\n        alert {\n          id\n        }\n        category {\n          id\n          name\n        }\n        isExpertTopRated\n      }\n    }\n  }\n}"

/***/ })

}]);